import { tr } from './util'
export default {
  // FIXME: Unused translation
  COMPANY: tr({
    en: 'Skillfit',
    de: 'Skillfit',
  }),
  /*
   * format
   **********************************************************************/
  format: {
    // @../pages/CourseAssetPage/CourseAssetPage.tsx:66
    // @../pages/CoursePage/CoursePageAssets.tsx:127
    // @../components/basics/FileInput/FileInput.tsx:305
    BYTES: tr({
      en: '{{bytes, bytes}}',
      de: '{{bytes, bytes}}',
    }),
    // @../components/LearningItemTeaser/LearningItemTeaser.tsx:161
    // @../pages/InsightsPage/InsightsPageCertificates.tsx:57
    // @../pages/InsightsPage/InsightsPageFinishedLearningItems.tsx:59
    // @../pages/InsightsPage/InsightsPageFinishedLearningItems.tsx:63
    // @../pages/InsightsPage/InsightsPageLearningInvestment.tsx:169
    // @../pages/InsightsPage/InsightsPageLearningInvestment.tsx:171
    // @../pages/ManageUserPage/ManageUserPageAchievements.tsx:71
    // @../components/learningAssignmentForms/EditUserLearningAssignmentForm/EditUserLearningAssignmentForm.tsx:106
    DATE: tr({
      en: '{{date, datetime}}',
      de: '{{date, datetime}}',
    }),
    // @../pages/DashboardPage/DashboardPageSchedule.tsx:59
    MONTHYEAR: tr({
      en: '{{date, datetime(month: long; year: numeric)}}',
      de: '{{date, datetime(month: long; year: numeric)}}',
    }),
    // @../pages/DashboardPage/DashboardPageSchedule.tsx:67
    DAYMONTH: tr({
      en: '{{date, datetime(day: numeric; month: short)}}',
      de: '{{date, datetime(day: numeric; month: short)}}',
    }),
    // @../components/EditLearningItemForm/ScheduledCourseEventsForm.tsx:96
    // @../pages/CoursePage/CoursePageScheduledCourse.tsx:127
    // @../pages/CoursePage/CoursePageScheduledCourse.tsx:368
    // @../pages/ManageUserPage/ManageUserPageLearningAssignments.tsx:145
    // @../components/learningAssignmentForms/CreateGroupLearningAssignmentsForm/CreateGroupLearningAssignmentsForm.tsx:193
    // @../components/learningAssignmentForms/CreateUserLearningAssignmentsForm/CreateUserLearningAssignmentsForm.tsx:238
    // @../components/learningAssignmentForms/CreateUserLearningAssignmentsForm/CreateUserLearningAssignmentsForm.tsx:249
    // @../components/learningAssignmentForms/CreateUserLearningAssignmentsForm/CreateUserLearningAssignmentsForm.tsx:277
    // @../components/learningAssignmentForms/MarkLearningItemAsFinishedDialog/MarkLearningItemAsFinishedDialog.tsx:101
    DATERANGE: tr({
      en: '{{range, daterange}}',
      de: '{{range, daterange}}',
    }),
    // @../pages/NotificationCenterPage/NotificationCenterPage.tsx:102
    // @../components/comments/CommentsList/CommentsList.tsx:195
    // @../components/comments/ThreadsDisplay/ThreadsDisplay.tsx:59
    DATETIME: tr({
      en: '{{date, datetime(dateStyle: short; timeStyle: short)}}',
      de: '{{date, datetime(dateStyle: short; timeStyle: short)}}',
    }),
    // @../components/NotificationBell/NotificationBell.tsx:68
    RELATIVEDATE: tr({
      en: '{{date, relativedate}}',
      de: '{{date, relativedate}}',
    }),
    // @../pages/CoursePage/CoursePageScheduledCourse.tsx:184
    // @../pages/EventDateAttendeesListPage/EventDateAttendeesList.tsx:57
    DATETIMERANGE: tr({
      en: '{{range, datetimerange}}',
      de: '{{range, datetimerange}}',
    }),
    // @../pages/DashboardPage/DashboardPageSchedule.tsx:73
    TIMERANGE: tr({
      en: '{{range, timerange}}',
      de: '{{range, timerange}}',
    }),
    // @../pages/DashboardPage/DashboardPageSchedule.tsx:74
    TIME: tr({
      en: '{{date, datetime(timeStyle: short)}}',
      de: '{{date, datetime(timeStyle: short)}}',
    }),
    // @../pages/InsightsPage/InsightsPageFinishedLearningItems.tsx:67
    // @../pages/InsightsPage/InsightsPageLearningInvestment.tsx:199
    DURATION: tr({
      en: '{{duration, duration}}',
      de: '{{duration, duration}}',
    }),
    // @../pages/CoursePage/CoursePage.tsx:65
    // @../state/calculations/learningItemInfoText.ts:11
    '{count} MINUTES': tr({
      en: {
        zero: '{{count}} minutes',
        one: '{{count}} minute',
        other: '{{count}} minutes',
      },
      de: {
        zero: '{{count}} Minuten',
        one: '{{count}} Minute',
        other: '{{count}} Minuten',
      },
    }),
    // @../pages/InsightsPage/InsightsPageLearningInvestmentChart.tsx:81
    '{count} min': tr({
      en: '{{count}} min',
      de: '{{count}} min',
    }),
    // @../pages/CoursePage/CoursePage.tsx:69
    // @../components/formElements/SelectLanguages/SelectLanguages.tsx:20
    // @../components/formElements/SelectLanguages/SelectLanguages.tsx:37
    LANGUAGE: tr({
      en: '{{code, language}}',
      de: '{{code, language}}',
    }),
  },
  /*
   * basic
   **********************************************************************/
  basic: {
    // @../components/basics/FileInput/FileInput.tsx:130
    fileinput: {
      // @../components/basics/FileInput/FileInput.tsx:281
      hint: tr({
        en: {
          zero: 'Click or drag here to add files.',
          one: 'Click or drag here to select a file.',
          other: 'Click or drag here to select up to {{count}} files.',
        },
        de: {
          zero: 'Hier klicken oder Dateien in dieses Feld ziehen.',
          one: 'Hier klicken oder eine Datei in dieses Feld ziehen.',
          other: 'Hier klicken oder Dateien in dieses Feld ziehen um bis zu {{count}} Dateien auszuwählen.',
        },
      }),
      // @../components/basics/FileInput/FileInput.tsx:283
      'accepts {types}': tr({
        en: 'File types: {{types}}.',
        de: 'Dateitypen: {{types}}.',
      }),
      // @../components/basics/FileInput/FileInput.tsx:287
      'maxsize {bytes}': tr({
        en: 'Maximum file size is {{bytes, BYTES}}.',
        de: 'Maximal {{bytes, BYTES}}.',
      }),
      filetype: {
        // @../components/assetForms/CreateAssetForm/CreateAssetForm.tsx:18
        image: tr({
          en: 'Image',
          de: 'Bild',
        }),
        // @../components/assetForms/CreateAssetForm/CreateAssetForm.tsx:30
        audio: tr({
          en: 'Audio',
          de: 'Audio',
        }),
        // @../components/assetForms/CreateAssetForm/CreateAssetForm.tsx:24
        video: tr({
          en: 'Video',
          de: 'Video',
        }),
        // @../components/assetForms/CreateAssetForm/CreateAssetForm.tsx:36
        pdf: tr({
          en: 'PDF',
          de: 'PDF',
        }),
        // @../components/assetForms/CreateAssetForm/CreateAssetForm.tsx:42
        powerpoint: tr({
          en: 'Powerpoint',
          de: 'Powerpoint',
        }),
        // @../components/assetForms/CreateAssetForm/CreateAssetForm.tsx:49
        zip: tr({
          en: 'ZIP',
          de: 'ZIP',
        }),
      },
    },
  },
  /*
   * errors
   **********************************************************************/
  errors: {
    fileinput: {
      // @../utilities/getErrorMesssage.ts:23
      // @../utilities/setFormErrors.ts:27
      // @../components/basics/FileInput/FileInput.tsx:145
      'please select at most {count} files': tr({
        en: {
          one: 'Please select only one file.',
          other: 'Please select at most {{count}}files.',
        },
        de: {
          one: 'Bitte nur eine Datei auswählen.',
          other: 'Bitte höchstens {{count}} Dateien auswählen.',
        },
      }),
      // @../utilities/getErrorMesssage.ts:23
      // @../utilities/setFormErrors.ts:27
      // @../components/basics/FileInput/FileInput.tsx:153
      'there are {count} files too large': tr({
        en: {
          one: 'The file is too large.',
          other: '{{count}} files are too large.',
        },
        de: {
          one: 'Die Datei ist zu groß.',
          other: '{{count}} Dateien sind zu groß.',
        },
      }),
      // @../utilities/getErrorMesssage.ts:23
      // @../utilities/setFormErrors.ts:27
      // @../components/basics/FileInput/FileInput.tsx:156
      'there are {count} files with wrong type': tr({
        en: {
          one: 'The file type is not accepted.',
          other: '{{count}} files have an inacceptible type.',
        },
        de: {
          one: 'Der Dateityp wird nicht akzeptiert.',
          other: '{{count}} Dateien haben einen nicht akzeptierten Dateityp.',
        },
      }),
      // @../utilities/getErrorMesssage.ts:23
      // @../utilities/setFormErrors.ts:27
      // @../components/basics/FileInput/FileInput.tsx:160
      'there are {count} inacceptible files': tr({
        en: {
          one: 'The file is not accepted.',
          other: '{{count}} files are not accepted.',
        },
        de: {
          one: 'Die Datei wird nicht akzeptiert.',
          other: '{{count}} Dateien werden nicht akzeptiert.',
        },
      }),
      file: {
        // @../utilities/getErrorMesssage.ts:23
        // @../utilities/setFormErrors.ts:27
        // @../components/basics/FileInput/FileInput.tsx:307
        'file-too-large': tr({
          en: 'The file is too large',
          de: 'Die Datei is zu groß',
        }),
        // @../utilities/getErrorMesssage.ts:23
        // @../utilities/setFormErrors.ts:27
        // @../components/basics/FileInput/FileInput.tsx:307
        'invalid-type': tr({
          en: 'Invalid file type.',
          de: 'Falscher Dateityp',
        }),
      },
    },
    fields: {
      email: {
        // @../utilities/getErrorMesssage.ts:19
        // @../utilities/getErrorMesssage.ts:23
        // @../utilities/setFormErrors.ts:23
        // @../utilities/setFormErrors.ts:27
        'validation-unique': tr({
          en: 'A user with that email address already exists.',
          de: 'Ein/e Benutzer/in mit dieser E-Mail-Adresse existiert bereits.',
        }),
        // @../utilities/getErrorMesssage.ts:19
        // @../utilities/getErrorMesssage.ts:23
        // @../utilities/setFormErrors.ts:23
        // @../utilities/setFormErrors.ts:27
        'validation-email': tr({
          en: 'Please enter a valid email address.',
          de: 'Bitte gib eine gültige E-Mail-Adresse ein.',
        }),
      },
      username: {
        // @../utilities/getErrorMesssage.ts:19
        // @../utilities/getErrorMesssage.ts:23
        // @../utilities/setFormErrors.ts:23
        // @../utilities/setFormErrors.ts:27
        'validation-unique': tr({
          en: 'A user with that username address already exists.',
          de: 'Ein/e Benutzer/in mit diesem Benutzernamen existiert bereits.',
        }),
      },
      externalId: {
        // @../utilities/getErrorMesssage.ts:19
        // @../utilities/getErrorMesssage.ts:23
        // @../utilities/setFormErrors.ts:23
        // @../utilities/setFormErrors.ts:27
        'validation-exists': tr({
          en: 'A course with that Scorm Cloud Id already exists.',
          de: 'Es gibt bereits einen Kurs mit dieser Scorm Cloud Id.',
        }),
      },
      name: {
        // @../utilities/getErrorMesssage.ts:19
        // @../utilities/getErrorMesssage.ts:23
        // @../utilities/setFormErrors.ts:23
        // @../utilities/setFormErrors.ts:27
        'validation-exists': tr({
          en: 'This name is already in use.',
          de: 'Dieser Name is bereits vergeben.',
        }),
      },
      title: {
        'The title has already been taken-': tr({
          en: 'The title has already been taken.',
          de: `The title has already been taken.`,
        }),
      },
      default: {
        // @../utilities/getErrorMesssage.ts:19
        // @../utilities/getErrorMesssage.ts:19
        // @../utilities/getErrorMesssage.ts:23
        // @../utilities/setFormErrors.ts:23
        // @../utilities/setFormErrors.ts:23
        // @../utilities/setFormErrors.ts:27
        'validation-active_url': tr({
          en: 'Please enter a URL.',
          de: `Bitte gib eine URL ein.`,
        }),
        // @../utilities/getErrorMesssage.ts:19
        // @../utilities/getErrorMesssage.ts:19
        // @../utilities/getErrorMesssage.ts:23
        // @../utilities/setFormErrors.ts:23
        // @../utilities/setFormErrors.ts:23
        // @../utilities/setFormErrors.ts:27
        'validation-required': tr({
          en: 'Please fill out this field.',
          de: 'Bitte fülle dieses Feld aus.',
        }),
      },
      text: {
        'not longer then': tr({
          en: 'The text must not exceed {{number}} characters',
          de: 'The text must not exceed {{number}} characters',
        }),
      },
      message: {
        'not longer then': tr({
          en: 'Your message exceeds the character limit of {{number}}!',
          de: 'Deine Nachricht übersteigt das Limit von {{number}} Zeichen!',
        }),
      },
    },
    // @../utilities/getErrorMesssage.ts:23
    // @../utilities/setFormErrors.ts:27
    // @../components/userAndGroupForms/SetPasswordForm/SetPasswordForm.tsx:65
    'password-invalid': tr({
      en: 'The current password is not correct.',
      de: 'Das aktuelle Passwort stimmt nicht.',
    }),
    // @../utilities/getErrorMesssage.ts:23
    // @../utilities/setFormErrors.ts:27
    // @../components/EditLearningItemForm/EditLearningItemForm.tsx:233
    // @../components/EditLearningItemForm/EditLearningItemForm.tsx:234
    'link or address required': tr({
      en: 'Fill out meeting link or address',
      de: `Fülle den Meeting-Link oder die Adresse aus`,
    }),
    // @../utilities/getErrorMesssage.ts:23
    // @../utilities/setFormErrors.ts:27
    // @../components/EditLearningItemForm/EditLearningItemForm.tsx:237
    'end date must be after start date': tr({
      en: 'The end date must be after the start date',
      de: `Das Enddatum muss nach dem Startdatum liegen`,
    }),
    // @../utilities/getErrorMesssage.ts:23
    // @../utilities/setFormErrors.ts:27
    // @../components/EditLearningItemForm/EditLearningItemForm.tsx:241
    'event must have dates': tr({
      en: 'Please add at least one date',
      de: `Bitte füge einen Termin hinzu`,
    }),
    // @../utilities/getErrorMesssage.ts:23
    // @../utilities/setFormErrors.ts:27
    // @../components/EditLearningItemForm/EditLearningItemForm.tsx:245
    'course must have events': tr({
      en: 'Please add at least one date',
      de: `Bitte füge einen Termin hinzu`,
    }),
    // @../utilities/getErrorMesssage.ts:23
    // @../utilities/setFormErrors.ts:27
    // @../components/LoginForm/LoginForm.tsx:55
    'login failed': tr({
      en: 'Incorrect user name or password',
      de: 'Benutzername oder Passwort stimmen nicht',
    }),
    // @../utilities/getErrorMesssage.ts:23
    // @../utilities/setFormErrors.ts:27
    'status-archived': tr({
      en: 'The course could not be saved because it is deprecated.',
      de: 'Der Kurs konnte nicht gespeichert werden, da er bereits geschlossen ist.',
    }),
    // @../utilities/getErrorMesssage.ts:23
    // @../utilities/setFormErrors.ts:27
    'status-booked': tr({
      en: 'The course could not be saved as draft because it already has bookings.',
      de: 'Der Kurs konnte nicht als Entwurf gespeichert werden, da er bereits Buchungen hat.',
    }),
    // @../utilities/getErrorMesssage.ts:23
    // @../utilities/setFormErrors.ts:27
    'client-booked': tr({
      en: 'The client of a course can not be changed.',
      de: 'Der Mandant eines Kurses kann nicht geändert werden.',
    }),
    // @../utilities/getErrorMesssage.ts:23
    // @../utilities/setFormErrors.ts:27
    'provider-not_found': tr({
      en: 'The provider was not found.',
      de: 'Der Anbieter wurde nicht gefunden.',
    }),
    // @../utilities/getErrorMesssage.ts:23
    // @../utilities/setFormErrors.ts:27
    'trainer-user_not_trainer': tr({
      en: 'A person selected as trainer is not a trainer.',
      de: 'Eine als TrainerIn ausgewählte Person ist keine TrainerIn.',
    }),
    // @../utilities/getErrorMesssage.ts:23
    // @../utilities/setFormErrors.ts:27
    'trainer-not_found': tr({
      en: 'Trainer not found.',
      de: 'TrainerIn nicht gefunden.',
    }),
    // @../utilities/getErrorMesssage.ts:23
    // @../utilities/setFormErrors.ts:27
    'user-is_manager': tr({
      en: 'The user can not be deleted because they are managers of one or more groups.',
      de: 'Der/die BenutzerIn kann nicht gelöscht werden, da er/sie eine oder mehrere Gruppen managed.',
    }),
    // @../utilities/getErrorMesssage.ts:23
    // @../utilities/setFormErrors.ts:27
    // @../pages/ManageUserPage/ManageUserPage.tsx:174
    // @../pages/ManageUserPage/ManageUserPage.tsx:175
    // @../components/userAndGroupForms/CreateUserForm/CreateUserForm.tsx:53
    // @../components/userAndGroupForms/CreateUserForm/CreateUserForm.tsx:54
    'username or email required': tr({
      en: 'Fill out email address or username.',
      de: `Fülle E-Mail-Adresse oder Benutzernamen aus.`,
    }),
  },
  /*
   * generic cta
   **********************************************************************/
  'generic cta': {
    // @../components/LoginForm/LoginForm.tsx:180
    back: tr({
      en: 'Back',
      de: 'Zurück',
    }),
    // @../components/FavoriteBadge/FavoriteBadge.tsx:25
    // @../components/GroupUserOperations/GroupUserOperations.tsx:47
    // @../components/GroupUserOperations/GroupUserOperations.tsx:75
    // @../pages/CoursePage/CoursePageAssets.tsx:78
    // @../pages/ManageGroupPage/ManageGroupPage.tsx:269
    // @../pages/ManageGroupPage/ManageGroupPageLearningAssignments.tsx:48
    // @../pages/ManageUserPage/ManageUserPage.tsx:56
    // @../pages/ManageUserPage/ManageUserPage.tsx:111
    // @../pages/ManageUserPage/ManageUserPageLearningAssignments.tsx:62
    // @../pages/ManageUserPage/ManageUserPageLearningAssignments.tsx:94
    // @../pages/ManageUsersPage/ManageUsersPage.tsx:48
    // @../components/basics/FormButtons/FormButtons.tsx:62
    // @../components/comments/CommentsList/CommentsList.tsx:133
    // @../components/comments/CommentsList/CommentsList.tsx:157
    cancel: tr({
      en: 'Cancel',
      de: 'Abbrechen',
    }),
    // @../components/EditLearningItemForm/EditLearningItemForm.tsx:179
    // @../components/userAndGroupForms/UserAvatarForm/UserAvatarForm.tsx:50
    discard: tr({
      en: 'Discard',
      de: 'Verwerfen',
    }),
    // @../pages/CoursePage/CoursePage.tsx:210
    // @../pages/EditGroupLearningAssignmentPage/EditGroupLearningAssignmentPage.tsx:24
    // @../pages/EditUserLearningAssignmentPage/EditUserLearningAssignmentPage.tsx:24
    // @../pages/ManageGroupPage/ManageGroupPage.tsx:251
    // @../pages/ManageGroupPage/ManageGroupPageLearningAssignments.tsx:111
    // @../pages/ManageUserPage/ManageUserPageLearningAssignments.tsx:217
    // @../components/comments/CommentsList/CommentsList.tsx:122
    edit: tr({
      en: 'Edit',
      de: 'Bearbeiten',
    }),
    // @../components/basics/ConfirmDialog/ConfirmDialog.tsx:24
    // @../components/learningAssignmentForms/MarkLearningItemAsFinishedDialog/MarkLearningItemAsFinishedDialog.tsx:113
    no: tr({
      en: 'No',
      de: 'Nein',
    }),
    // @../components/EditLearningItemForm/EditLearningItemForm.tsx:184
    // @../components/FavoriteBadge/FavoriteBadge.tsx:25
    // @../components/GroupUserOperations/GroupUserOperations.tsx:47
    // @../components/GroupUserOperations/GroupUserOperations.tsx:75
    // @../pages/ManageGroupPage/ManageGroupPageLearningAssignments.tsx:48
    // @../pages/ManageUserPage/ManageUserPageLearningAssignments.tsx:62
    // @../pages/ManageUserPage/ManageUserPageLearningAssignments.tsx:94
    // @../components/userAndGroupForms/UserAvatarForm/UserAvatarForm.tsx:55
    remove: tr({
      en: 'Remove',
      de: 'Entfernen',
    }),
    // @../pages/ManageGroupPage/ManageGroupPage.tsx:266
    // @../pages/ManageUserPage/ManageUserPage.tsx:220
    // @../components/basics/FormButtons/FormButtons.tsx:56
    // @../components/userAndGroupForms/UserAvatarForm/UserAvatarForm.tsx:70
    save: tr({
      en: 'Save',
      de: 'Speichern',
    }),
    // @../pages/CoursePage/CoursePageAssets.tsx:78
    // @../pages/ManageUserPage/ManageUserPage.tsx:56
    // @../pages/ManageUserPage/ManageUserPage.tsx:111
    // @../pages/ManageUsersPage/ManageUsersPage.tsx:48
    // @../components/basics/ConfirmDialog/ConfirmDialog.tsx:23
    // @../components/comments/CommentsList/CommentsList.tsx:133
    // @../components/comments/CommentsList/CommentsList.tsx:157
    // @../components/learningAssignmentForms/MarkLearningItemAsFinishedDialog/MarkLearningItemAsFinishedDialog.tsx:112
    yes: tr({
      en: 'Yes',
      de: 'Ja',
    }),
    // @../pages/ManageUsersPage/ManageUsersPage.tsx:248
    'select action': tr({
      en: 'Select Action',
      de: 'Aktion auswählen',
    }),
    // @../components/LoginForm/LoginForm.tsx:130
    // @../components/LoginForm/LoginForm.tsx:142
    // @../components/basics/MessageBox/MessageBox.tsx:21
    // @../components/userAndGroupForms/SetPasswordForm/SetPasswordForm.tsx:58
    ok: tr({
      en: 'Ok',
      de: 'Ok',
    }),
    // @../pages/DashboardPage/DashboardPage.tsx:57
    'show all': tr({
      en: 'Show all',
      de: 'Alle anzeigen',
    }),
    // @../components/EditLearningItemForm/EditLearningItemForm.tsx:193
    // @../components/userAndGroupForms/UserAvatarForm/UserAvatarForm.tsx:65
    upload: tr({
      en: 'Upload',
      de: 'Hochladen',
    }),
    // @../components/notificationComponents/notificationComponents.tsx:366
    // @../components/notificationComponents/notificationComponents.tsx:416
    // @../components/notificationComponents/notificationComponents.tsx:440
    // @../components/notificationComponents/notificationComponents.tsx:463
    // @../components/notificationComponents/notificationComponents.tsx:486
    // @../components/notificationComponents/notificationComponents.tsx:509
    // @../components/notificationComponents/notificationComponents.tsx:536
    // @../components/notificationComponents/notificationComponents.tsx:559
    // @../components/notificationComponents/notificationComponents.tsx:635
    // @../components/notificationComponents/notificationComponents.tsx:660
    // @../components/notificationComponents/notificationComponents.tsx:684
    // @../components/notificationComponents/notificationComponents.tsx:711
    // @../components/notificationComponents/notificationComponents.tsx:738
    // @../components/notificationComponents/notificationComponents.tsx:761
    // @../components/notificationComponents/notificationComponents.tsx:784
    // @../components/notificationComponents/notificationComponents.tsx:807
    // @../components/notificationComponents/notificationComponents.tsx:838
    // @../components/notificationComponents/notificationComponents.tsx:868
    view: tr({
      en: 'View',
      de: 'Ansehen',
    }),
  },
  /*
   * browse courses
   **********************************************************************/
  'browse courses': {
    // @../pages/CoursesPage/CoursesPage.tsx:87
    // @../pages/CoursesPage/CoursesPage.tsx:88
    // @../pages/DashboardPage/DashboardPage.tsx:53
    wishlist: tr({
      en: 'Wishlist',
      de: 'Wunschliste',
    }),
    // @../pages/CoursesPage/CoursesPage.tsx:171
    'cta hide filters': tr({
      en: 'Hide filters',
      de: 'Filter ausblenden',
    }),
    // @../pages/CoursesPage/CoursesPage.tsx:164
    'cta reset filters': tr({
      en: 'Reset filter',
      de: 'Filter löschen',
    }),
    // @../pages/DashboardPage/DashboardPage.tsx:62
    'wishlist empty': tr({
      en: "Here you will find your favorites. So far, you haven't saved any favorites.",
      de: 'Hier findest Du Deine Favoriten. Bisher hast Du noch keine Favoriten hinterlegt.',
    }),
    // @../pages/CoursesPage/CoursesPage.tsx:171
    'cta show filters': tr({
      en: 'Show filters',
      de: 'Filter einblenden',
    }),
    // @../components/Search/Search.tsx:78
    'search courses': tr({
      en: 'Search courses',
      de: 'Kurse suchen',
    }),
    // @../components/Search/Search.tsx:59
    'cta search in all courses': tr({
      en: 'Search for "{{term}}" in all courses',
      de: 'Nach "{{term}}" in allen Kursen suchen',
    }),
    // @../pages/CoursesPage/CoursesPage.tsx:160
    'cta show results': tr({
      en: 'Show results',
      de: 'Ergebnisse anzeigen',
    }),
    // @../pages/CoursesPage/CoursesPage.tsx:202
    'courses empty': tr({
      en: 'No courses found',
      de: 'Keine Kurse gefunden',
    }),
    // @../components/MainNav/MainNav.tsx:60
    // @../pages/CoursesPage/CoursesPage.tsx:226
    'page title': tr({
      en: 'Courses',
      de: 'Kurse',
    }),
    // @../pages/CoursesPage/CoursesPage.tsx:89
    'only favorites': tr({
      en: 'Only Favorites',
      de: 'Nur Favoriten',
    }),
    // @../pages/CoursesPage/CoursesPage.tsx:180
    'title courses': tr({
      en: 'Discover the right course',
      de: 'Entdecke den passenden Kurs',
    }),
    // @../components/FavoriteBadge/FavoriteBadge.tsx:27
    'should learning item <title> be removed from favorites': tr({
      en: 'Remove "{{title}}" from your favorites?',
      de: 'Soll "{{title}}" aus den Favoriten entfernt werden?',
    }),
  },
  /*
   * notifications
   **********************************************************************/
  notifications: {
    // @../pages/NotificationCenterPage/NotificationCenterPage.tsx:52
    'page title': tr({
      en: 'Notifications',
      de: 'Benachrichtigungen',
    }),
    // @../pages/NotificationCenterPage/NotificationCenterPage.tsx:138
    breadcrumb: tr({
      en: 'Notifications',
      de: 'Benachrichtigungen',
    }),
    // @../pages/NotificationCenterPage/NotificationCenterPage.tsx:115
    'no notifications found': tr({
      en: 'No notifications',
      de: 'Keine Benachrichtigungen',
    }),
    // @../components/NotificationBell/NotificationBell.tsx:82
    'no unread notifications found': tr({
      en: 'No unread notifications',
      de: 'Keine ungelesenen Benachrichtigungen',
    }),
    userCreated: {
      // @../components/notificationComponents/notificationComponents.tsx:59
      message: tr({
        en: 'Dear {{firstname}}, welcome to $t(COMPANY)! We have prepared a short introduction course (5 min) for you to start your journey.',
        de: 'Hallo {{firstname}}, willkommen bei $t(COMPANY)! Wir haben einen kurzen Einführungskurs (5 min) für Dich vorbereitet.',
      }),
    },
    userAddedToGroup: {
      // @../components/notificationComponents/notificationComponents.tsx:73
      message: tr({
        en: 'User <0/> added you to the group <1/>.',
        de: 'BenutzerIn <0/> hat Dich zur Gruppe <1/> hinzugefügt.',
      }),
    },
    userRemovedFromGroup: {
      // @../components/notificationComponents/notificationComponents.tsx:96
      message: tr({
        en: 'User <0/> has removed you from the group <1/>.',
        de: 'BenutzerIn <0/> hat Dich aus der Gruppe <1/> entfernt.',
      }),
    },
    userAddedAsManagerToGroup: {
      // @../components/notificationComponents/notificationComponents.tsx:119
      message: tr({
        en: 'In the <1/> group <0/> has given you the role "manager".',
        de: '<0/> hat Dir in der Gruppe <1/> die Rolle "Gruppenmanager" zugewiesen.',
      }),
    },
    userRemovedAsManagerFromGroup: {
      // @../components/notificationComponents/notificationComponents.tsx:142
      message: tr({
        en: 'In the <1/> group <0/> has removed the role "manager" from your profile.',
        de: '<0/> hat in der Gruppe <1/> Deine Rollenzuweisung "Gruppenmanager" entfernt.',
      }),
    },
    userAddedLearningSuggestionNotification: {
      // @../components/notificationComponents/notificationComponents.tsx:166
      message: tr({
        en: '<0/> suggested the course <1>"{{title}}"</1> to you.',
        de: '<0/> hat Dir den Kurs <1>"{{title}}"</1> empfohlen.',
      }),
    },
    userAddedLearningAssignmentNotification: {
      // @../components/notificationComponents/notificationComponents.tsx:186
      message: tr({
        en: 'You have received <1>"{{title}}"</1> as a new assignment from <0/>, which is due on {{dueDate, datetime}}.',
        de: 'Du hast <1>"{{title}}"</1> als neue Zuweisung (Frist bis {{dueDate, datetime}}) von <0/> erhalten.',
      }),
    },
    userAddedLearningAssignmentWithdrawnNotification: {
      // @../components/notificationComponents/notificationComponents.tsx:207
      message: tr({
        en: 'The assignment for <1>"{{title}}"</1> has been widthdrawn by <0/>.',
        de: 'Die Zuweisung zum Kurs <1>"{{title}}"</1> wurde von <0/> entfernt.',
      }),
    },
    userAddedLearningAssignmentLiveEventNotification: {
      // @../components/notificationComponents/notificationComponents.tsx:233
      'message without date': {
        // @../components/notificationComponents/notificationComponents.tsx:236
        hybrid: tr({
          en: 'You have been booked to the hybrid course <1>"{{title}}"</1> by <0/>.',
          de: 'Du wurdest von <0/> auf den Hybrid-Kurs <1>"{{title}}"</1> gebucht.',
        }),
        // @../components/notificationComponents/notificationComponents.tsx:236
        live_training: tr({
          en: 'You have been booked to the live event <1>"{{title}}"</1> by <0/>.',
          de: 'Du wurdest von <0/> auf das Live Event <1>"{{title}}"</1> gebucht.',
        }),
        // @../components/notificationComponents/notificationComponents.tsx:236
        webinar: tr({
          en: 'You have been booked to the webinar <1>"{{title}}"</1> by <0/>.',
          de: 'Du wurdest von <0/> auf das Webinar <1>"{{title}}"</1> gebucht.',
        }),
      },
      // @../components/notificationComponents/notificationComponents.tsx:241
      message: {
        // @../components/notificationComponents/notificationComponents.tsx:247
        hybrid: tr({
          en: 'You have been booked to the hybrid course <1>"{{title}}"</1> starting on {{date, datetime}} by <0/>.',
          de: 'Du wurdest von <0/> auf den Hybrid-Kurs <1>"{{title}}"</1> (Start: {{date, datetime}}) gebucht.',
        }),
        // @../components/notificationComponents/notificationComponents.tsx:247
        live_training: tr({
          en: 'You have been booked to the live event course <1>"{{title}}"</1> starting on {{date, datetime}} by <0/>.',
          de: 'Du wurdest von <0/> auf das Live Event <1>"{{title}}"</1> (Start: {{date, datetime}}) gebucht.',
        }),
        // @../components/notificationComponents/notificationComponents.tsx:247
        webinar: tr({
          en: 'You have been booked to the webinar <1>"{{title}}"</1> starting on {{date, datetime}} by <0/>.',
          de: 'Du wurdest von <0/> auf das Webinar <1>"{{title}}"</1> (Start: {{date, datetime}}) gebucht.',
        }),
      },
    },
    groupAddedLearningSuggestionNotification: {
      // @../components/notificationComponents/notificationComponents.tsx:270
      message: tr({
        en: 'Your group <0/> has <2>"{{title}}"</2> as a new assignment from <1/>',
        de: 'Deine Gruppe <0/> hat den Kurs <2>"{{title}}"</2> von <1/> empfohlen bekommen.',
      }),
    },
    groupAddedLearningAssignmentNotification: {
      // @../components/notificationComponents/notificationComponents.tsx:298
      message: tr({
        en: 'Your group <0/> has <2>"{{title}}"</2> as a new assignment from <1/>, which is due on {{dueDate, datetime}}.',
        de: 'Deine Gruppe <0/> hat den Kurs <2>"{{title}}"</2> (Frist: {{dueDate, datetime}}) von <1/> zugewiesen bekommen.',
      }),
    },
    userUpcomingEvent3DaysNotification: {
      // @../components/notificationComponents/notificationComponents.tsx:334
      message: tr({
        en:
          'Your booked live event <0>"{{title}}"</0> on {{date, datetime}} will take place in {{location}}.\n' +
          'Please check the course page for details like agenda, ticket, or directions.',
        de:
          'Dein gebuchter Kurs <0>"{{title}}"</0> wird am {{date, datetime}} (Ort: {{location}}) stattfinden.\n' +
          'Weitere Details wie eine Agenda, Tickets, oder Infos zur Anreise kannst du auf der Kursseite finden.',
      }),
      // @../components/notificationComponents/notificationComponents.tsx:344
      message_virtual: tr({
        en:
          'Your booked live event <0>"{{title}}"</0> on {{date, datetime}} will take place under <1>{{location}}</1>.\n' +
          'Please check the course page for details like agenda, ticket, or directions.',
        de:
          'Dein gebuchter Kurs <0>"{{title}}"</0> wird am {{date, datetime}} (Link: <1>{{location}}</1>) stattfinden.\n' +
          'Weitere Details wie eine Agenda, Tickets, oder Infos zur Anreise kannst du auf der Kursseite finden.',
      }),
      // @../components/notificationComponents/notificationComponents.tsx:354
      message_no_location: tr({
        en:
          'Your booked live event <0>"{{title}}"</0> will take place on {{date, datetime}}.\n' +
          'Please check the course page for details like agenda, ticket, or directions.',
        de:
          'Dein gebuchter Kurs <0>"{{title}}"</0> wird am {{date, datetime}} stattfinden.\n' +
          'Weitere Details wie eine Agenda, Tickets, oder Infos zur Anreise kannst du auf der Kursseite finden.',
      }),
    },
    userUpcomingEventNotification: {
      // @../components/notificationComponents/notificationComponents.tsx:387
      message: tr({
        en:
          'Your booked live event <0>"{{title}}"</0> in {{location}} will take place tomorrow.\n' +
          'Please check the course page for details like agenda, ticket, or directions.',
        de:
          'Dein gebuchter Kurs <0>"{{title}}"</0> wird morgen (Ort: {{location}}) stattfinden.\n' +
          'Weitere Details wie eine Agenda, Tickets, oder Infos zur Anreise kannst du auf der Kursseite finden.',
      }),
      // @../components/notificationComponents/notificationComponents.tsx:396
      message_virtual: tr({
        en:
          'Your booked live event <0>"{{title}}"</0> tomorrow will take place under <1>{{location}}</1>.\n' +
          'Please check the course page for details like agenda, ticket, or directions.',
        de:
          'Dein gebuchter Kurs <0>"{{title}}"</0> wird morgen (Link: <1>{{location}}</1>) stattfinden.\n' +
          'Weitere Details wie eine Agenda, Tickets, oder Infos zur Anreise kannst du auf der Kursseite finden.',
      }),
      // @../components/notificationComponents/notificationComponents.tsx:405
      message_no_location: tr({
        en:
          'Your booked live event <0>"{{title}}"</0> will take place tomorrow.\n' +
          'Please check the course page for details like agenda, ticket, or directions.',
        de:
          'Dein gebuchter Kurs <0>"{{title}}"</0> wird am morgen stattfinden.\n' +
          'Weitere Details wie eine Agenda, Tickets, oder Infos zur Anreise kannst du auf der Kursseite finden.',
      }),
    },
    courseFinishedNotification: {
      // @../components/notificationComponents/notificationComponents.tsx:428
      message: tr({
        en: 'Congratulations! You successfully finished <0>"{{title}}"</0>.',
        de: 'Gratulation! Du hast den Kurs <0>"{{title}}"</0> erfolgreich abgeschlossen.',
      }),
    },
    courseFinishedNotificationLink: {
      message: tr({
        en: 'Congratulations! You successfully finished <0>"{{title}}"</0>.<br><br> <b>Help us improve the quality even further!</b> Share your feedback and let us know what you valued most. <1>Give your feedback here.</1>',
        de: 'Congratulations! You successfully finished <0>"{{title}}"</0>.<br><br> <b>Help us improve the quality even further!</b> Share your feedback and let us know what you valued most. <1>Give your feedback here.</1>',
      }),
    },
    userLearningAssignmentDue7DaysNotification: {
      // @../components/notificationComponents/notificationComponents.tsx:452
      message: tr({
        en: 'Your assignment for <0>"{{title}}"</0> is due in 7 days.',
        de: 'Deine Zuweisung für <0>"{{title}}"</0> ist in 7 Tagen fällig.',
      }),
    },
    userLearningAssignmentDue3DaysNotification: {
      // @../components/notificationComponents/notificationComponents.tsx:475
      message: tr({
        en: 'Your assignment for <0>"{{title}}"</0> is due in 3 days.',
        de: 'Deine Zuweisung für <0>"{{title}}"</0> ist in 3 Tagen fällig.',
      }),
    },
    userLearningAssignmentOverdueNotification: {
      // @../components/notificationComponents/notificationComponents.tsx:498
      message: tr({
        en: 'Your assignment for <0>"{{title}}"</0> was due until today.',
        de: 'Deine Zuweisung für <0>"{{title}}"</0> ist heute fällig.',
      }),
    },
    managerUserFinishedLearningAssignmentNotification: {
      // @../components/notificationComponents/notificationComponents.tsx:523
      message: tr({
        en: '<0/> from the group <1/> has finished <2>"{{title}}"</2>.',
        de: '<0/> aus der Gruppe <1/> hat den Kurs <2>"{{title}}"</2> abgeschlossen.',
      }),
    },
    managerLearningAssignmentOverdueNotification: {
      // @../components/notificationComponents/notificationComponents.tsx:548
      message: tr({
        en: 'There are members with outstanding courses in your group <1>“{{groupTitle}}”<1>.',
        de: 'In deiner Gruppe <1>“{{groupTitle}}”<1> befinden sich heute fällige Kurszuweisungen die noch nicht abgeschlossen wurden.',
      }),
    },
    managerGroupFinishedLearningAssignmentNotification: {
      // @../components/notificationComponents/notificationComponents.tsx:572
      message: tr({
        en: 'The group <0/> has completed the assignment <1>"{{title}}"</1>.',
        de: 'Die Gruppe <0/> hat den Kurs <1>"{{title}}"</1> vollständig abgeschlossen.',
      }),
    },
    managerGroupLearningAssignmentOverdueNotification: {
      // @../components/notificationComponents/notificationComponents.tsx:597
      message: tr({
        en: 'The assignment <1>"{{title}}"</1> for <0/> which is due on {{dueDate, datetime}} is only finished at {{completionRate}}%.',
        de: 'Die Kurszuweisung <1>"{{title}}"</1> für die Gruppe <0/> war am {{dueDate, datetime}} fällig, wurde jedoch nur zu {{completionRate}}% abgeschlossen.',
      }),
    },
    certificateAvailableNotification: {
      // @../components/notificationComponents/notificationComponents.tsx:623
      message: tr({
        en: `Your certificate for <0>"{{title}}"</0> is ready and can be downloaded.`,
        de: 'Das Zertifikat für deinen abgeschlossenen Kurs <0>"{{title}}"</0> ist jetzt bereit und kann heruntergeladen werden.',
      }),
    },
    certificateInvalidation60DaysNotification: {
      // @../components/notificationComponents/notificationComponents.tsx:647
      message: tr({
        en: `Your certificate for <0>"{{title}}"</0> is going to loose validity on {{validUntil, datetime}}.`,
        de: 'Das Zertifikat für <0>"{{title}}"</0> verliert am {{validUntil, datetime}} seine Gültigkeit.',
      }),
    },
    certificateInvalidationNotification: {
      // @../components/notificationComponents/notificationComponents.tsx:672
      message: tr({
        en: `Today your certification for <0>"{{title}}"</0> expired.`,
        de: 'Das Zertifikat für <0>"{{title}}"</0> verliert heute seine Gültigkeit.',
      }),
    },
    managerCertificateInvalidation60DaysNotification: {
      // @../components/notificationComponents/notificationComponents.tsx:697
      message: tr({
        en: `<1/>'s certification for <0>"{{title}}"</0> will become invalid in two months ({{validUntil, datetime}}).`,
        de: 'Das Zertifikat für <0>"{{title}}"</0> von <1/> wird in zwei Monaten ({{validUntil, datetime}}) seine Gültigkeit verlieren.',
      }),
    },
    managerCertificateInvalidationNotification: {
      // @../components/notificationComponents/notificationComponents.tsx:724
      message: tr({
        en: `<1/>'s certification for <0>"{{title}}"</0> devalidated on {{validUntil, datetime}}.`,
        de: 'Das Zertifikat für <0>"{{title}}"</0> von <1/> hat am {{validUntil, datetime}} seine Gültigkeit verloren.',
      }),
    },
    scheduledCourseChangedNotification: {
      // @../components/notificationComponents/notificationComponents.tsx:750
      message: tr({
        en: `The data of your course <0/> has updated. Please check the course details page for more information.`,
        de: `Die Daten deines Kurses <0/> haben sich geändert. Bitte überprüfe die Details auf der Kursseite.`,
      }),
    },
    scheduledCourseEventDeletedNotification: {
      // @../components/notificationComponents/notificationComponents.tsx:772
      message: tr({
        en: `Your event of the <0>"{{title}}"</0> course has been canceled. Please check the course details page for more information.`,
        de: `Ihre Veranstaltung zum Kurs <0>"{{title}}"</0> wurde abgesagt. Bitte überprüfen Sie die Kursdetailseite für weitere Informationen.`,
      }),
    },
    courseAttachmentAvailableNotification: {
      // @../components/notificationComponents/notificationComponents.tsx:796
      message: tr({
        en: `For your course <0/> there is new material available. Go to the course detail page to take a look at these items.`,
        de: `Für deinen Kurs <0/> ist neues Material verfügbar. Gehe zur Kursseite um die Einzelheiten anzusehen.`,
      }),
    },
    topicAddedInCourseDiscussionNotification: {
      // @../components/notificationComponents/notificationComponents.tsx:819
      message: tr({
        en: `<0/> has added a new topic "{{title}}" to the <1>"{{learningItemTitle}}"</1> course discussion.`,
        de: `<0/> hat ein neues Topic "{{title}}" im Kurs <1>"{{learningItemTitle}}"</1> erstellt.`,
      }),
    },
    commentAddedInCourseDiscussionNotification: {
      // @../components/notificationComponents/notificationComponents.tsx:850
      message: tr({
        en: `<0/> has added a new comment in the <1>"{{learningItemTitle}}"</1> course discussion.`,
        de: `<0/> hat ein neues Kommentar zu einer Diskussion im Kurs <1>"{{learningItemTitle}}"</1> hinzugefügt.`,
      }),
    },
    courseRemovedFromLearningPathNotification: {
      message: tr({
        en: `The following courses have been removed from your learning path <0>“{{title}}”</0> by {{user}}: {{courses}}`,
        de: `The following courses have been removed from your learning path <0>“{{title}}”</0> by {{user}}: {{courses}}`,
      }),
    },
    courseAddedToLearningPathNotification: {
      message: tr({
        en: `Your learning path <0>“{{title}}”</0> got the following courses added by {{user}}: {{courses}}`,
        de: `Your learning path <0>“{{title}}”</0> got the following courses added by {{user}}: {{courses}}`,
      }),
    },
    // @../pages/NotificationCenterPage/NotificationCenterPage.tsx:70
    'cta mark read': tr({
      en: 'Mark read',
      de: 'Als gelesen markieren',
    }),
    // @../components/NotificationBell/NotificationBell.tsx:89
    'cta mark all read': tr({
      en: 'Mark all read',
      de: 'Alle als gelesen markieren',
    }),
    // @../pages/NotificationCenterPage/NotificationCenterPage.tsx:73
    'cta delete': tr({
      en: 'Delete',
      de: 'Löschen',
    }),
    // @../components/NotificationBell/NotificationBell.tsx:86
    'cta view all': tr({
      en: 'All notifications',
      de: 'Alle Benachrichtungen',
    }),
  },
  /*
   * dashboard
   **********************************************************************/
  dashboard: {
    // @../components/MainNav/MainNav.tsx:55
    'page title': tr({
      en: 'Dashboard',
      de: 'Dashboard',
    }),
    // @../pages/DashboardPage/DashboardPage.tsx:76
    breadcrumb: tr({
      en: 'Home',
      de: 'Home',
    }),
    // @../pages/DashboardPage/DashboardPage.tsx:39
    'title learning suggestions': tr({
      en: 'Learning Suggestions',
      de: 'Vorschläge',
    }),
    // @../pages/DashboardPage/DashboardPage.tsx:40
    'learning suggestions empty': tr({
      en: 'There are no suggestions yet.',
      de: 'Noch keine Vorschläge.',
    }),
    // @../pages/DashboardPage/DashboardPageSchedule.tsx:50
    'title my schedule': tr({
      en: 'My Schedule',
      de: 'Meine Termine',
    }),
    // @../pages/DashboardPage/DashboardPageSchedule.tsx:104
    'schedule empty': tr({
      en: 'Your schedule is empty.',
      de: 'Keine Termine gefunden.',
    }),
    // @../pages/DashboardPage/DashboardPageContinueLearning.tsx:33
    'title continue learning': tr({
      en: 'Continue Learning',
      de: 'Weiter lernen',
    }),
    // @../pages/DashboardPage/DashboardPageContinueLearning.tsx:36
    'continue learning empty': tr({
      en: 'Here you can find your courses. At the moment, you have not started any courses.',
      de: 'Hier findest Du Deine Kurse. Im Moment hast Du noch keine Kurse begonnen.',
    }),
    // @../pages/DashboardPage/DashboardPageContinueLearning.tsx:39
    'cta browse now': tr({
      en: 'Browse now',
      de: 'Jetzt Kurse ansehen',
    }),
  },
  /*
   * insights
   **********************************************************************/
  insights: {
    // @../pages/InsightsPage/InsightsPageLearningInvestmentFunnel.tsx:80
    'number of courses finished': tr({
      en: 'Courses finished',
      de: 'Abgeschlossene Kurse',
    }),
    // @../pages/InsightsPage/InsightsPageLearningInvestmentFunnel.tsx:76
    'number of courses started': tr({
      en: 'Courses started',
      de: 'Gestartete Kurse',
    }),
    // @../pages/InsightsPage/InsightsPageLearningInvestmentFunnel.tsx:72
    'number of booked or assigned courses': tr({
      en: 'Booked or assigned courses',
      de: 'Gebuchte oder zugewiesene Kurse',
    }),
    // @../pages/InsightsPage/InsightsPageLearningInvestment.tsx:146
    'title my learning investment': tr({
      en: 'My Learning Investment',
      de: 'Lerninvestment',
    }),
    // @../pages/InsightsPage/InsightsPageLearningInvestment.tsx:191
    'title my top courses': tr({
      en: 'My top courses',
      de: 'Meine Top Kurse',
    }),
    // @../pages/InsightsPage/InsightsPageLearningInvestment.tsx:179
    'total {minutes} spent from {start} to {end}': tr({
      en: '<0>{{minutes}} min</0><1>spent learning</1><2>between {{start, datetime}} and {{end, datetime}}</2>',
      de: '<0>{{minutes}} min</0><1>investiert</1><2>vom {{start, datetime}} bis {{end, datetime}}</2>',
    }),
    // @pages/InsightsPage/InsightsPageLearningInvestment.tsx (161,32)
    // @pages/InsightsPage/InsightsPageLearningInvestment.tsx (166,24)
    'time range': {
      // @../pages/InsightsPage/InsightsPageLearningInvestment.tsx:152
      // @../pages/InsightsPage/InsightsPageLearningInvestment.tsx:156
      range12months: tr({
        en: '12 months',
        de: '12 Monate',
      }),
      // @../pages/InsightsPage/InsightsPageLearningInvestment.tsx:152
      // @../pages/InsightsPage/InsightsPageLearningInvestment.tsx:156
      range6months: tr({
        en: '6 months',
        de: '6 Monate',
      }),
      // @../pages/InsightsPage/InsightsPageLearningInvestment.tsx:152
      // @../pages/InsightsPage/InsightsPageLearningInvestment.tsx:156
      range1month: tr({
        en: '1 month',
        de: '1 Monat',
      }),
      // @../pages/InsightsPage/InsightsPageLearningInvestment.tsx:152
      // @../pages/InsightsPage/InsightsPageLearningInvestment.tsx:156
      range1week: tr({
        en: '1 week',
        de: '1 Woche',
      }),
    },
    // @../components/MainNav/MainNav.tsx:65
    // @../pages/InsightsPage/InsightsPage.tsx:33
    'page title': tr({
      en: 'Insights',
      de: 'Insights',
    }),
  },
  /*
   * learning path
   **********************************************************************/
  'learning path': {
    'field title': tr({
      en: 'Title',
      de: 'Titel',
    }),
    'field categories': tr({
      en: 'Categories',
      de: 'Kategorien',
    }),
    'field description': tr({
      en: 'Description',
      de: 'Beschreibung',
    }),
    'field certificate mode': tr({
      en: 'Certificate',
      de: 'Zertifikat',
    }),
    'field certificate validity': tr({
      en: 'Valid until',
      de: 'Gültig bis',
    }),
    'certificate mode': {
      none: tr({
        en: 'No certificate',
        de: 'Kein Zertifikat',
      }),
      limited: tr({
        en: 'Limited validity',
        de: 'Begrenzte Gültigkeit',
      }),
      unlimited: tr({
        en: 'Unlimited validity',
        de: 'Unbegrenzte Gültigkeit',
      }),
    },
    'enrolled users and groups': tr({
      en: 'Enrolled users and groups',
      de: 'Enrolled users and groups',
    }),
    'courses list title': tr({
      en: 'Learning items',
      de: 'Learning items',
    }),
    'already added': tr({
      en: 'Already added',
      de: 'Already added',
    }),
    '{count} events': tr({
      en: {
        one: 'single event',
        other: '{{count}} events',
      },
      de: {
        one: 'single event',
        other: '{{count}} events',
      },
    }),
    'on demand': tr({
      en: 'On demand',
      de: 'On demand',
    }),
    'no learning items': tr({
      en: 'No learning items yet',
      de: 'No learning items yet',
    }),
    'no entries yet': tr({
      en: 'No entries yet',
      de: 'No entries yet',
    }),
    'error add learning item': tr({
      en: 'Please add at least one learning item',
      de: 'Please add at least one learning item',
    }),
    list: {
      scheduled_details: {
        date: tr({
          en: 'Date',
          de: 'Date',
        }),
        title: tr({
          en: 'Title',
          de: 'Title',
        }),
        location: tr({
          en: 'Location',
          de: 'Location',
        }),
        trainer: tr({
          en: 'Trainer',
          de: 'Trainer',
        }),
      },
    },
  },
  /*
   * learning item
   **********************************************************************/
  'learning item': {
    // FIXME: Unused translation
    'field client': tr({
      en: 'Client',
      de: 'Mandant',
    }),
    // @../components/EditLearningItemForm/EditLearningItemForm.tsx:317
    'field is global': tr({
      en: 'Available for all clients',
      de: 'Für alle Mandanten verfügbar',
    }),
    // @../pages/CoursesPage/CoursesPage.tsx:128
    // @../pages/CoursesPage/CoursesPage.tsx:131
    'field status': tr({
      en: 'Status',
      de: 'Status',
    }),
    'edit field status': tr({
      en: 'Course status',
      de: 'Course status',
    }),
    'status draft error': tr({
      en: 'There are users booked or assigned to this course. Please remove them before changing the status to draft.',
      de: 'There are users booked or assigned to this course. Please remove them before changing the status to draft.',
    }),
    // @../components/EditLearningItemForm/EditLearningItemForm.tsx:313
    'field title': tr({
      en: 'Title',
      de: 'Titel',
    }),
    // @../components/EditLearningItemForm/EditLearningItemForm.tsx:376
    'field description': tr({
      en: 'Description',
      de: 'Beschreibung',
    }),
    // @../pages/CoursePage/CoursePage.tsx:59
    // @../pages/CoursePage/CoursePageScheduledCourse.tsx:60
    // @../pages/CoursesPage/CoursesPage.tsx:115
    // @../pages/CoursesPage/CoursesPage.tsx:118
    categories: tr({
      en: 'Categories',
      de: 'Kategorien',
    }),
    // @../components/EditLearningItemForm/EditLearningItemForm.tsx:336
    'field categories': tr({
      en: 'Categories',
      de: 'Kategorien',
    }),
    // @../pages/CoursePage/CoursePageAssets.tsx:169
    'field assets': tr({
      en: 'Attachments',
      de: 'Anhänge',
    }),
    // @../pages/CoursePage/CoursePageAssets.tsx:184
    'assets empty': tr({
      en: 'No attachments',
      de: 'Keine Anhänge',
    }),
    // @../components/EditLearningItemForm/EditLearningItemForm.tsx:359
    'field certificate mode': tr({
      en: 'Certificate',
      de: 'Zertifikat',
    }),
    // @../components/EditLearningItemForm/EditLearningItemForm.tsx:370
    'field certificate validity': tr({
      en: 'Valid until',
      de: 'Gültig bis',
    }),
    // @../pages/CoursePage/CoursePage.tsx:54
    // @../pages/CoursePage/CoursePageScheduledCourse.tsx:55
    quickFacts: tr({
      en: 'Quick facts',
      de: 'Eckdaten',
    }),
    // @../components/EditLearningItemForm/EditLearningItemForm.tsx:350
    'field duration in min': tr({
      en: 'Duration in Minutes',
      de: 'Dauer in Minuten',
    }),
    // @../pages/CoursePage/CoursePage.tsx:78
    // @../pages/CoursePage/CoursePageScheduledCourse.tsx:72
    // @../pages/InsightsPage/InsightsPageFinishedLearningItems.tsx:45
    // @../pages/InsightsPage/InsightsPageFinishedLearningItems.tsx:72
    price: tr({
      en: 'Price',
      de: 'Preis',
    }),
    certificate: tr({
      en: 'Certificate',
      de: 'Zertifikat',
    }),
    // @../components/EditLearningItemForm/EditLearningItemForm.tsx:331
    // @../pages/CoursePage/CoursePageScheduledCourse.tsx:67
    'field provider': tr({
      en: 'Provider',
      de: 'Anbieter',
    }),
    // @../components/EditLearningItemForm/EditLearningItemForm.tsx:354
    // @../pages/CoursePage/CoursePage.tsx:67
    contentLanguage: tr({
      en: 'Language',
      de: 'Sprache',
    }),
    // @../pages/CoursePage/CoursePage.tsx:64
    duration: tr({
      en: 'Duration',
      de: 'Dauer',
    }),
    // @../components/EditLearningItemForm/ScheduledCourseEventsForm.tsx:112
    'field max attendees': tr({
      en: 'Max attendees',
      de: 'Max. TeilnehmerInnen',
    }),
    // @../components/EditLearningItemForm/ScheduledCourseEventsForm.tsx:207
    // @../pages/CoursePage/CoursePageScheduledCourse.tsx:115
    // @../pages/CoursePage/CoursePageScheduledCourse.tsx:348
    'scheduled course events': tr({
      en: 'Events',
      de: 'Events',
    }),
    // @../components/EditLearningItemForm/ScheduledCourseEventsForm.tsx:153
    // @../pages/CoursePage/CoursePageScheduledCourse.tsx:163
    'field scheduled course date title': tr({
      en: 'Title',
      de: 'Titel',
    }),
    // @../components/EditLearningItemForm/ScheduledCourseEventsForm.tsx:139
    'field scheduled course date start date': tr({
      en: 'Start',
      de: 'Beginn',
    }),
    // @../components/EditLearningItemForm/ScheduledCourseEventsForm.tsx:146
    'field scheduled course date end date': tr({
      en: 'End',
      de: 'Ende',
    }),
    // @../pages/CoursePage/CoursePageScheduledCourse.tsx:162
    'field scheduled course date date': tr({
      en: 'Date',
      de: 'Datum',
    }),
    // @../pages/CoursePage/CoursePageScheduledCourse.tsx:167
    'scheduled course date location': tr({
      en: 'Location',
      de: 'Ort',
    }),
    // @../components/EditLearningItemForm/ScheduledCourseEventsForm.tsx:159
    'field meeting address': tr({
      en: 'Address',
      de: 'Adresse',
    }),
    // @../components/EditLearningItemForm/ScheduledCourseEventsForm.tsx:164
    'field meeting link': tr({
      en: 'Link',
      de: 'Link',
    }),
    // @../state/calculations/scheduleItems.tsx:68
    'Meeting Link': tr({
      en: 'Meeting Link',
      de: 'Teilnahmelink',
    }),
    // @../components/EditLearningItemForm/ScheduledCourseEventsForm.tsx:171
    // @../pages/CoursePage/CoursePageScheduledCourse.tsx:165
    'field scheduled course date trainers': tr({
      en: 'Trainer',
      de: 'Trainer',
    }),
    // @../pages/CoursePage/CoursePageScheduledCourse.tsx:327
    // @../pages/EventDateAttendeesListPage/EventDateAttendeesListPage.tsx:21
    'scheduled course participants': tr({
      en: 'Participants',
      de: 'TeilnehmerInnen',
    }),
    // @../components/EditLearningItemForm/EditLearningItemForm.tsx:343
    'field external id': tr({
      en: 'Scorm Cloud Id',
      de: 'Scorm Cloud Id',
    }),
    type: {
      // @../components/LearningItemTeaser/LearningItemTeaser.tsx:158
      // @../components/Search/Search.tsx:65
      // @../pages/CoursePage/CoursePage.tsx:172
      // @../pages/CoursesPage/CoursesPage.tsx:105
      // @../pages/ManageGroupPage/ManageGroupPageLearningAssignments.tsx:168
      // @../pages/ManageUserPage/ManageUserPageAchievements.tsx:40
      // @../pages/ManageUserPage/ManageUserPageLearningAssignments.tsx:333
      online_class: tr({
        en: 'E-Learning',
        de: 'E-Learning',
      }),
      // @../components/LearningItemTeaser/LearningItemTeaser.tsx:158
      // @../components/Search/Search.tsx:65
      // @../pages/CoursePage/CoursePage.tsx:172
      // @../pages/CoursesPage/CoursesPage.tsx:105
      // @../pages/ManageGroupPage/ManageGroupPageLearningAssignments.tsx:168
      // @../pages/ManageUserPage/ManageUserPageAchievements.tsx:40
      // @../pages/ManageUserPage/ManageUserPageLearningAssignments.tsx:333
      learning_path: tr({
        en: 'Learning Path',
        de: 'Lernpfad',
      }),
      // @../components/LearningItemTeaser/LearningItemTeaser.tsx:158
      // @../components/Search/Search.tsx:65
      // @../pages/CoursePage/CoursePage.tsx:172
      // @../pages/CoursesPage/CoursesPage.tsx:105
      // @../pages/ManageGroupPage/ManageGroupPageLearningAssignments.tsx:168
      // @../pages/ManageUserPage/ManageUserPageAchievements.tsx:40
      // @../pages/ManageUserPage/ManageUserPageLearningAssignments.tsx:333
      live_training: tr({
        en: 'Live Training',
        de: 'Live Training',
      }),
      // @../components/LearningItemTeaser/LearningItemTeaser.tsx:158
      // @../components/Search/Search.tsx:65
      // @../pages/CoursePage/CoursePage.tsx:172
      // @../pages/CoursesPage/CoursesPage.tsx:105
      // @../pages/ManageGroupPage/ManageGroupPageLearningAssignments.tsx:168
      // @../pages/ManageUserPage/ManageUserPageAchievements.tsx:40
      // @../pages/ManageUserPage/ManageUserPageLearningAssignments.tsx:333
      webinar: tr({
        en: 'Webinar',
        de: 'Webinar',
      }),
      // @../components/LearningItemTeaser/LearningItemTeaser.tsx:158
      // @../components/Search/Search.tsx:65
      // @../pages/CoursePage/CoursePage.tsx:172
      // @../pages/CoursesPage/CoursesPage.tsx:105
      // @../pages/ManageGroupPage/ManageGroupPageLearningAssignments.tsx:168
      // @../pages/ManageUserPage/ManageUserPageAchievements.tsx:40
      // @../pages/ManageUserPage/ManageUserPageLearningAssignments.tsx:333
      hybrid: tr({
        en: 'Hybrid',
        de: 'Hybrid',
      }),
    },
    // @../components/StartCourseLink/StartCourseLink.tsx:60
    // @../pages/CoursePage/CoursePage.tsx:196
    // @../pages/CoursePage/CoursePageScheduledCourse.tsx:155
    book: tr({
      en: 'Book',
      de: 'Buchen',
    }),
    // @../components/StartCourseLink/StartCourseLink.tsx:35
    start: tr({
      en: 'Start',
      de: 'Starten',
    }),
    // @../components/LearningItemTeaser/LearningItemTeaser.tsx:191
    // @../components/StartCourseLink/StartCourseLink.tsx:35
    continue: tr({
      en: 'Continue',
      de: 'Fortsetzen',
    }),
    // @../pages/CoursePage/CoursePage.tsx:192
    // @../pages/CoursePlayPage/CoursePlayPage.tsx:64
    preview: tr({
      en: 'Preview',
      de: 'Vorschau',
    }),
    // @../components/StartCourseLink/StartCourseLink.tsx:48
    join: tr({
      en: 'Join',
      de: 'Teilnehmen',
    }),
    // @../components/StartCourseLink/StartCourseLink.tsx:67
    view: tr({
      en: 'View',
      de: 'Ansehen',
    }),
    // @../components/LearningItemTeaser/LearningItemTeaser.tsx:169
    'duration in minutes': tr({
      en: '<0>Duration: </0> {{duration, duration}}',
      de: '<0>Dauer: </0> {{duration, duration}}',
    }),
    // @../pages/CoursesPage/CoursesPage.tsx:96
    // @../pages/CoursesPage/CoursesPage.tsx:99
    'learning format': tr({
      en: 'Learning format',
      de: 'Lernformat',
    }),
    // @../components/LearningItemTeaser/LearningItemTeaser.tsx:193
    // @../pages/CoursePage/CoursePage.tsx:79
    // @../pages/CoursePage/CoursePageScheduledCourse.tsx:73
    // @../pages/InsightsPage/InsightsPageFinishedLearningItems.tsx:73
    included: tr({
      en: 'Included',
      de: 'Inkludiert',
    }),
    // @../pages/CoursePage/CoursePageScheduledCourse.tsx:131
    '{count} dates': tr({
      en: {
        one: 'single date',
        other: '{{count}} dates',
      },
      de: {
        one: 'ein Termin',
        other: '{{count}} Termine',
      },
    }),

    // @../pages/ManageGroupPage/ManageGroupPageLearningAssignments.tsx:196
    // @../pages/ManageUserPage/ManageUserPageAchievements.tsx:83
    // @../pages/ManageUserPage/ManageUserPageLearningAssignments.tsx:360
    // @../state/calculations/scheduleItems.tsx:71
    // @../state/calculations/scheduleItems.tsx:88
    'due date is': tr({
      en: 'Due date {{date, datetime}}',
      de: 'Frist {{date, datetime}}',
    }),
    // @../pages/DashboardPage/DashboardPageSchedule.tsx:71
    // @../components/learningAssignmentForms/CreateGroupLearningAssignmentsForm/CreateGroupLearningAssignmentsForm.tsx:176
    // @../components/learningAssignmentForms/CreateUserLearningAssignmentsForm/CreateUserLearningAssignmentsForm.tsx:221
    // @../components/learningAssignmentForms/EditGroupLearningAssignmentForm/EditGroupLearningAssignmentForm.tsx:79
    // @../components/learningAssignmentForms/EditUserLearningAssignmentForm/EditUserLearningAssignmentForm.tsx:97
    // @../components/learningAssignmentForms/EditUserLearningAssignmentForm/EditUserLearningAssignmentForm.tsx:110
    'due date': tr({
      en: 'Due date',
      de: 'Frist',
    }),
    // @../pages/InsightsPage/InsightsPageFinishedLearningItems.tsx:44
    // @../pages/InsightsPage/InsightsPageFinishedLearningItems.tsx:66
    'time spent': tr({
      en: 'Time Spent',
      de: 'Investierte Zeit',
    }),
    // @../components/learningAssignmentForms/EditUserLearningAssignmentForm/EditUserLearningAssignmentForm.tsx:96
    'assigned at': tr({
      en: 'Assigned on',
      de: 'Zugewiesen',
    }),
    // @../pages/DashboardPage/DashboardPageSchedule.tsx:61
    // @../components/learningAssignmentForms/EditUserLearningAssignmentForm/EditUserLearningAssignmentForm.tsx:95
    'assigned by': tr({
      en: 'Assigned by',
      de: 'Zugewiesen durch',
    }),
    // @../pages/ManageUserPage/ManageUserPageAchievements.tsx:69
    'finished at': tr({
      en: 'Finished At',
      de: 'Abgeschlossen am',
    }),
    // @../pages/ManageUserPage/ManageUserPageAchievements.tsx:48
    // @../pages/ManageUserPage/ManageUserPageLearningAssignments.tsx:341
    'assigned {at} <by> {till}': tr({
      en: '{{at, datetime}} by <0/> till {{till, datetime}}',
      de: '{{at, datetime}} durch <0/> bis {{till, datetime}}',
    }),
    'assigned {at} <by>': tr({
      en: '{{at, datetime}} by <0/>',
      de: '{{at, datetime}} durch <0/>',
    }),
    'next session {at}': tr({
      en: 'Next session at {{at, datetime}}',
      de: 'Next session at {{at, datetime}}',
    }),
    // @../pages/ManageGroupPage/ManageGroupPageLearningAssignments.tsx:176
    'assigned {at}': tr({
      en: '{{at, datetime}}',
      de: '{{at, datetime}}',
    }),
    // @../components/DueIn/DueIn.tsx:27
    'due in {date}': tr({
      en: 'Due {{date, relativedate}}',
      de: 'Fällig {{date, relativedate}}',
    }),
    // @../state/calculations/scheduleItems.tsx:115
    'no events before due date': tr({
      en: 'No events before due date',
      de: 'Keine Termine vor Ablauf der Frist',
    }),
    // @../state/calculations/scheduleItems.tsx:100
    'last event before due date': tr({
      en: 'One available event before due date',
      de: 'Noch ein verfügbarer Termin vor Ablauf der Frist',
    }),
    // @../state/calculations/scheduleItems.tsx:88
    'bookable event': tr({
      en: 'Bookable event',
      de: 'Buchbares Event',
    }),
    // @../state/calculations/learningItemInfoText.ts:18
    '<count> future events from <firstDate> to <lastDate>': tr({
      en: {
        zero: 'No future events',
        one: 'One future event starting {{firstDate, datetime}}',
        other: `{{count}} future events starting between {{firstDate, datetime}} and {{lastDate, datetime}}`,
      },
      de: {
        zero: 'Keine zukünftigen Veranstaltungen',
        one: 'Eine zukünftige Veranstaltung am {{firstDate, datetime}}',
        other: `{{count}} zukünftige Veranstaltungen zwischen {{firstDate, datetime}} und {{lastDate, datetime}}`,
      },
    }),
    // @../pages/CoursePage/CoursePageScheduledCourse.tsx:143
    // @../pages/ManageUserPage/ManageUserPageLearningAssignments.tsx:130
    // @../pages/ManageUserPage/ManageUserPageLearningAssignments.tsx:144
    booked: tr({
      en: 'Booked',
      de: 'Gebucht',
    }),
    // @../pages/CoursePlayPage/CoursePlayPage.tsx:66
    play: tr({
      en: 'Play',
      de: 'Abspielen',
    }),
    // @../pages/CourseCommentPage/CourseCommentPage.tsx:31
    // @../pages/CoursePlayPage/CoursePlayPage.tsx:49
    'cta back to course page': tr({
      en: 'Back to Course Page',
      de: 'Zurück zum Kurs',
    }),
    // @../pages/CoursePage/CoursePageScheduledCourse.tsx:132
    // @../components/learningAssignmentForms/CreateGroupLearningAssignmentsForm/CreateGroupLearningAssignmentsForm.tsx:195
    // @../components/learningAssignmentForms/CreateUserLearningAssignmentsForm/CreateUserLearningAssignmentsForm.tsx:251
    // @../components/learningAssignmentForms/CreateUserLearningAssignmentsForm/CreateUserLearningAssignmentsForm.tsx:279
    '{count} scheduled course event seats available': tr({
      en: {
        one: 'one seat available',
        other: '{{count}} seats available',
      },
      de: {
        one: 'ein Platz verfügbar',
        other: '{{count}} Plätze verfügbar',
      },
    }),
    status: {
      // @../components/LearningItemTeaser/LearningItemTeaser.tsx:183
      // @../pages/CoursePage/CoursePage.tsx:168
      // @../pages/CoursesPage/CoursesPage.tsx:136
      // @../components/learningAssignmentForms/CreateGroupLearningAssignmentsForm/CreateGroupLearningAssignmentsForm.tsx:97
      // @../components/learningAssignmentForms/CreateUserLearningAssignmentsForm/CreateUserLearningAssignmentsForm.tsx:120
      draft: tr({
        en: 'Draft',
        de: 'Entwurf',
      }),
      // @../components/LearningItemTeaser/LearningItemTeaser.tsx:183
      // @../pages/CoursePage/CoursePage.tsx:168
      // @../pages/CoursesPage/CoursesPage.tsx:144
      // @../components/learningAssignmentForms/CreateGroupLearningAssignmentsForm/CreateGroupLearningAssignmentsForm.tsx:97
      // @../components/learningAssignmentForms/CreateUserLearningAssignmentsForm/CreateUserLearningAssignmentsForm.tsx:120
      published: tr({
        en: 'Published',
        de: 'Veröffentlicht',
      }),
      // @../components/LearningItemTeaser/LearningItemTeaser.tsx:183
      // @../pages/CoursePage/CoursePage.tsx:168
      // @../pages/CoursesPage/CoursesPage.tsx:152
      // @../components/learningAssignmentForms/CreateGroupLearningAssignmentsForm/CreateGroupLearningAssignmentsForm.tsx:97
      // @../components/learningAssignmentForms/CreateUserLearningAssignmentsForm/CreateUserLearningAssignmentsForm.tsx:120
      deprecated: tr({
        en: 'Deprecated',
        de: 'Veraltet',
      }),
    },
    'certificate mode': {
      // @../components/EditLearningItemForm/EditLearningItemForm.tsx:361
      none: tr({
        en: 'No certificate',
        de: 'Kein Zertifikat',
      }),
      // @../components/EditLearningItemForm/EditLearningItemForm.tsx:362
      limited: tr({
        en: 'Limited validity',
        de: 'Begrenzte Gültigkeit',
      }),
      // @../components/EditLearningItemForm/EditLearningItemForm.tsx:363
      unlimited: tr({
        en: 'Unlimited validity',
        de: 'Unbegrenzte Gültigkeit',
      }),
    },
    // FIXME: Unused translation
    'global client': tr({
      en: 'Global',
      de: 'Global',
    }),
    // @../pages/CoursePage/CoursePageScheduledCourse.tsx:387
    'cta cancel booking': tr({
      en: 'Cancel booking',
      de: 'Cancel booking',
    }),
    // FIXME: Unused translation
    'cta book seat': tr({
      en: 'Book seat',
      de: 'Book seat',
    }),
    // FIXME: Unused translation
    'cancel {user} booking': tr({
      en: 'Should the booking for {{user}} be canceled?',
      de: 'Should the booking for {{user}} be canceled?',
    }),
    'nothing has changed in the form': tr({
      en: 'Nothing has changed in the form',
      de: 'Nothing has changed in the form',
    }),
  },

  /*
   * Attendees list
   **********************************************************************/
  attendees: {
    // @../pages/EventDateAttendeesListPage/EventDateAttendeesList.tsx:55
    'attendance tracking': tr({
      en: 'Attendance Tracking',
      de: 'Anwesenheitskontrolle',
    }),

    // @../pages/EventDateAttendeesListPage/EventDateAttendeesList.tsx:163
    'cta tracking completed': tr({
      en: 'Tracking completed',
      de: 'Tracking abgeschlossen',
    }),

    // @../pages/EventDateAttendeesListPage/EventDateAttendeesList.tsx:156
    'no attendees': tr({
      en: 'No participants',
      de: 'Keine Teilnehmer',
    }),
  },

  /*
   * asset
   **********************************************************************/
  asset: {
    // @../components/assetForms/EditAssetForm/EditAssetForm.tsx:58
    'field filename': tr({
      en: 'File name',
      de: 'Dateiname',
    }),
    // @../components/assetForms/CreateAssetForm/CreateAssetForm.tsx:150
    // @../components/assetForms/EditAssetForm/EditAssetForm.tsx:60
    'field description': tr({
      en: 'Description',
      de: 'Beschreibung',
    }),
    // @../components/assetForms/CreateAssetForm/CreateAssetForm.tsx:152
    // @../components/assetForms/EditAssetForm/EditAssetForm.tsx:62
    'field visibleFrom': tr({
      en: 'Visible from',
      de: 'Sichtbar ab',
    }),
    // @../components/assetForms/CreateAssetForm/CreateAssetForm.tsx:154
    // @../components/assetForms/EditAssetForm/EditAssetForm.tsx:64
    'field visibleUntil': tr({
      en: 'Visible until',
      de: 'Sichtbar bis',
    }),
    // @../pages/CoursePage/CoursePageAssets.tsx:50
    'asset not visible': tr({
      en: 'not currently visible',
      de: 'im Moment nicht sichtbar',
    }),
    'asset visible between': {
      // @../pages/CoursePage/CoursePageAssets.tsx:38
      'from <visibleFrom> until <visibleUntil>': tr({
        en: 'Visible from {{visibleFrom, datetime}} to {{visibleUntil, datetime}}',
        de: 'Sichtbar von {{visibleFrom, datetime}} bis {{visibleUntil, datetime}}',
      }),
      // @../pages/CoursePage/CoursePageAssets.tsx:43
      'from <visibleFrom>': tr({
        en: 'Visible from {{visibleFrom, datetime}}',
        de: 'Sichtbar ab {{visibleFrom, datetime}}',
      }),
      // @../pages/CoursePage/CoursePageAssets.tsx:46
      'until <visibleUntil>': tr({
        en: 'Visible until {{visibleUntil, datetime}}',
        de: 'Sichtbar bis {{visibleUntil, datetime}}',
      }),
    },
    // @../pages/CourseAssetPage/CourseAssetPage.tsx:71
    'cta download': tr({
      en: 'Download',
      de: 'Herunterladen',
    }),
    // @../pages/CoursePage/CoursePageAssets.tsx:172
    'cta new asset': tr({
      en: 'New Attachment',
      de: 'Anhang hinzufügen',
    }),
    // @../pages/CoursePage/CoursePageAssets.tsx:112
    'cta edit asset': tr({
      en: 'Edit',
      de: 'Bearbeiten',
    }),
    // @../pages/CoursePage/CoursePageAssets.tsx:96
    'cta delete asset': tr({
      en: 'Delete',
      de: 'Löschen',
    }),
    // @../pages/CoursePage/CoursePageAssets.tsx:80
    'should asset {filename} be deleted': tr({
      en: 'Really delete attachment "{{filename}}"?',
      de: 'Soll Anhang "{{filename}}" wirklich gelöscht werden?',
    }),
    // @../components/assetForms/CreateAssetForm/CreateAssetForm.tsx:137
    'title create asset': tr({
      en: 'Create Attachment',
      de: 'Anhang Hinzufügen',
    }),
    // @../components/assetForms/EditAssetForm/EditAssetForm.tsx:53
    'title edit asset': tr({
      en: 'Edit Attachment',
      de: 'Anhang Bearbeiten',
    }),
    // @../components/assetForms/CreateAssetForm/CreateAssetForm.tsx:144
    'select files': tr({
      en: 'Files',
      de: 'Dateien',
    }),
  },
  /*
   * certificate
   **********************************************************************/
  certificate: {
    // @../pages/ManageUserPage/ManageUserPageAchievements.tsx:60
    certificate: tr({
      en: 'Certificate',
      de: 'Zertifikat',
    }),
    // @../pages/InsightsPage/InsightsPageCertificates.tsx:32
    certificates: tr({
      en: 'Certificates',
      de: 'Zertifikate',
    }),
    // @../pages/InsightsPage/InsightsPageCertificates.tsx:67
    // @../components/slugs/CertificateSlug/CertificateSlug.tsx:26
    'download certificate': tr({
      en: 'Download',
      de: 'Herunterladen',
    }),
    // @../pages/ManageGroupPage/ManageGroupPageLearningAssignments.tsx:92
    'cta download group certificates': tr({
      en: 'Download all certificates',
      de: 'Alle Zertifikate herunterladen',
    }),
    // @../pages/InsightsPage/InsightsPageCertificates.tsx:40
    // @../pages/InsightsPage/InsightsPageCertificates.tsx:55
    'certificate validity': tr({
      en: 'Validity Period',
      de: 'Gültigkeit',
    }),
    // @../pages/InsightsPage/InsightsPageCertificates.tsx:42
    'certificate download': tr({
      en: 'Download',
      de: 'Download',
    }),
    // @../pages/InsightsPage/InsightsPageCertificates.tsx:41
    // @../pages/InsightsPage/InsightsPageCertificates.tsx:61
    'certificate status': tr({
      en: 'Status',
      de: 'Status',
    }),
    // @../pages/InsightsPage/InsightsPageCertificates.tsx:39
    // @../pages/InsightsPage/InsightsPageCertificates.tsx:51
    'certificate name': tr({
      en: 'Certificate',
      de: 'Zertifikat',
    }),
    // @../pages/InsightsPage/InsightsPageCertificates.tsx:77
    'certificates empty': tr({
      en: 'No certificates yet',
      de: 'Noch keine Zertifikate',
    }),
    // @../components/slugs/CertificateSlug/CertificateSlug.tsx:20
    'certificate id is <id>': tr({
      en: 'Id: {{id}}',
      de: 'Id: {{id}}',
    }),
    // @../components/CertificateValidity/CertificateValidity.tsx:26
    valid: tr({
      en: 'Valid',
      de: 'Gültig',
    }),
    // @../components/CertificateValidity/CertificateValidity.tsx:15
    invalid: tr({
      en: 'Invalid',
      de: 'ungültig',
    }),
    // @../pages/InsightsPage/InsightsPageCertificates.tsx:58
    'unlimited validity': tr({
      en: 'Unlimited',
      de: 'Unbegrenzt',
    }),
    // @../components/CertificateValidity/CertificateValidity.tsx:21
    '<count> days left': tr({
      en: {
        one: '{{count}} day left',
        other: '{{count}} days left',
      },
      de: {
        one: '{{count}} Tag verbleibend',
        other: '{{count}} Tage verbleibend',
      },
    }),
  },
  /*
   * manage learning
   **********************************************************************/
  'manage learning': {
    // @../pages/ManageGroupPage/ManageGroupPageLearningAssignments.tsx:146
    // @../pages/ManageUserPage/ManageUserPageLearningAssignments.tsx:252
    'cta remove learning assignment': tr({
      en: 'Remove assignment',
      de: 'Zuweisung entfernen',
    }),
    'should learning assignment be removed from user': tr({
      en: 'Should learning assignment by <1/> be removed for "{{title}}" from user <0/>?',
      de: 'Soll die Lernzuweisung "{{title}}" von <1/> an User <0/> entfernt werden?',
    }),
    // @../pages/ManageUserPage/ManageUserPageLearningAssignments.tsx:64
    'select which learning assignment be removed from user': tr({
      en: 'Choose user learning assignment to be removed for "{{title}}" from user <0/> :',
      de: 'Wähle die Lernzuweisung für Kurs "{{title}}" von User <0/> die entfernt werden soll:',
    }),
    // @../pages/ManageGroupPage/ManageGroupPageLearningAssignments.tsx:50
    'should learning assignment be removed from group': tr({
      en: 'Remove learning assignment for "{{title}}" from group <0/>?',
      de: 'Soll die Zuweisung der Lerneinheit "{{title}}" von der Gruppe <0/> entfernt werden?',
    }),
    // @../pages/ManageUserPage/ManageUserPageLearningAssignments.tsx:96
    'should booking be cancelled for user': tr({
      en: 'Should booking for "{{title}}" be cancelled for user <0/>?',
      de: 'Soll die Buchung für "{{title}}" für <0/> storniert werden?',
    }),
    // @../pages/AddLearningItemsToUserPage/AddLearningItemsToUserPage.tsx:21
    // @../pages/AddLearningItemsToUsersPage/AddLearningItemsToUsersPage.tsx:23
    'add learning items': tr({
      en: ``,
      de: ``,
    }),
    // @../pages/ManageGroupPage/ManageGroupPageLearningAssignments.tsx:226
    // @../pages/ManageUserPage/ManageUserPageLearningAssignments.tsx:418
    // @../pages/ManageUsersPage/ManageUsersPage.tsx:142
    'cta assign learning item': tr({
      en: 'Assign learning item',
      de: 'Lerneinheit zuweisen',
    }),
    // @../components/learningAssignmentForms/CreateGroupLearningAssignmentsForm/CreateGroupLearningAssignmentsForm.tsx:109
    // @../components/learningAssignmentForms/CreateUserLearningAssignmentsForm/CreateUserLearningAssignmentsForm.tsx:132
    'assign learning items': tr({
      en: 'Assign learning items',
      de: 'Lerneinheiten zuweisen',
    }),
    // @../pages/CreateGroupLearningAssignmentsPage/CreateGroupLearningAssignmentsPage.tsx:24
    'create learning assignments': tr({
      en: 'Assign courses & learning paths',
      de: 'Kurse & Lernpfade zuweisen',
    }),
    // @../components/learningAssignmentForms/EditGroupLearningAssignmentForm/EditGroupLearningAssignmentForm.tsx:47
    'edit learning assignment for group': tr({
      en: 'Edit learning assignment for group <0/>',
      de: 'Lernzuweisung für Gruppe <0/> bearbeiten',
    }),
    // @../components/learningAssignmentForms/EditUserLearningAssignmentForm/EditUserLearningAssignmentForm.tsx:78
    'edit learning assignment for user': tr({
      en: 'Edit learning assignment for user <0/>',
      de: 'Lernzuweisung für BenutzerIn <0/> bearbeiten',
    }),
    'mark as finished': {
      // @../components/learningAssignmentForms/MarkLearningItemAsFinishedDialog/MarkLearningItemAsFinishedDialog.tsx:81
      headline: tr({
        en: 'Mark course as finished',
        de: `Kurs abschliessen`,
      }),
      // @../components/learningAssignmentForms/MarkLearningItemAsFinishedDialog/MarkLearningItemAsFinishedDialog.tsx:69
      'learning item was marked as finished': tr({
        en: 'The course was marked as finished.',
        de: 'Der Kurs wurde abgeschlossen.',
      }),
      // @../components/learningAssignmentForms/MarkLearningItemAsFinishedDialog/MarkLearningItemAsFinishedDialog.tsx:84
      'should learning item {title} be marked as finished': tr({
        en: 'Should the course "{{title}}" be marked as finished?',
        de: 'Soll der Kurs "{{title}}" abgeschlossen werden?',
      }),
      // @../components/learningAssignmentForms/MarkLearningItemAsFinishedDialog/MarkLearningItemAsFinishedDialog.tsx:93
      'please select an event': tr({
        en: 'Please select an event',
        de: `Bitte wähle eine Veranstaltung aus.`,
      }),
      // @../pages/MarkLearningItemAsFinishedPage/MarkLearningItemAsFinishedPage.tsx:23
      breadcrumb: tr({
        en: 'Mark as finished',
        de: 'Abschliessen',
      }),
      // @../pages/ManageUserPage/ManageUserPageLearningAssignments.tsx:320
      'cta mark as finished': tr({
        en: 'Mark as finished',
        de: 'Abschliessen',
      }),
    },
    // @../components/LearningItemTeaser/LearningItemTeaser.tsx:86
    'cta assign to groups': tr({
      en: 'Assign to groups',
      de: 'An Gruppen zuweisen',
    }),
    // @../components/LearningItemTeaser/LearningItemTeaser.tsx:67
    'cta assign to users': tr({
      en: 'Assign to users',
      de: 'An BenutzerInnen zuweisen',
    }),
    // @../components/learningAssignmentForms/CreateGroupLearningAssignmentsForm/CreateGroupLearningAssignmentsForm.tsx:164
    // @../components/learningAssignmentForms/CreateUserLearningAssignmentsForm/CreateUserLearningAssignmentsForm.tsx:208
    'description suggest learning item for user': tr({
      en:
        'Suggest the current learning item to the selected user(s), or group(s).\n' +
        'It will appear on the user dashboard(s) as your suggestion.',
      de: `Schlage den ausgewählten Benutzer(n) oder Gruppe(n) die aktuelle Lerneinheit vor. Es wird auf dem Dashboard der Benutzer als deine Empfehlung angezeigt.`,
    }),
    // @../components/learningAssignmentForms/CreateGroupLearningAssignmentsForm/CreateGroupLearningAssignmentsForm.tsx:167
    // @../components/learningAssignmentForms/CreateUserLearningAssignmentsForm/CreateUserLearningAssignmentsForm.tsx:211
    'description assign learning item to user': tr({
      en:
        'Send the current learning item to the selected user(s), or group(s) as a mandatory assignment.\n' +
        'Your team member has the option to select a suitable event within your given deadline.',
      de: `Sende die aktuelle Lerneinheit an die ausgewählten Benutzer oder Gruppen als verpflichtende Zuweisung.
Das Teammitglied hat die Möglichkeit, innerhalb der gesetzten Frist einen passenden Termin auszuwählen.`,
    }),
    // @../components/learningAssignmentForms/CreateUserLearningAssignmentsForm/CreateUserLearningAssignmentsForm.tsx:213
    'description book learning item for user': tr({
      en:
        'Book a dedicated seat for each selected user at the above displayed course.\n' +
        'If there are not enough seats left and a waiting list is available, surplus user will be assigned to the waiting list.\n' +
        'This action results in a binding event booking.',
      de: `Buche einen festen Platz für jeden ausgewählten Benutzer bei dem oben angezeigten Kurs. Wenn nicht genügend Plätze verfügbar sind und eine Warteliste vorhanden ist, werden überschüssige Benutzer auf die Warteliste gesetzt. Diese Aktion führt zu einer verbindlichen Buchung.`,
    }),
    // @../components/learningAssignmentForms/CreateGroupLearningAssignmentsForm/CreateGroupLearningAssignmentsForm.tsx:129
    // @../components/learningAssignmentForms/CreateUserLearningAssignmentsForm/CreateUserLearningAssignmentsForm.tsx:152
    'description select action': tr({
      en: 'Please select which action you want to perform with the selected learning item.',
      de: `Bitte wähle aus, welche Aktion Du mit der ausgewählten Lerneinheit durchführen möchtest`,
    }),
    // @../components/formElements/SelectLearningItem/SelectLearningItem.tsx:32
    'no learning item selected': tr({
      en: 'No course selected',
      de: 'Kein Kurs ausgewählt',
    }),
    // @../components/learningAssignmentForms/CreateGroupLearningAssignmentsForm/CreateGroupLearningAssignmentsForm.tsx:114
    // @../components/learningAssignmentForms/CreateUserLearningAssignmentsForm/CreateUserLearningAssignmentsForm.tsx:137
    'step select learning item': tr({
      en: '1. Select a course',
      de: '1. Kurs auswählen',
    }),
    'step select learning path': tr({
      en: '1. Select a path',
      de: '1. Lernpfade auswählen',
    }),
    // @../components/learningAssignmentForms/CreateUserLearningAssignmentsForm/CreateUserLearningAssignmentsForm.tsx:143
    'step select users': tr({
      en: '2. Select users',
      de: `2. Benutzer auswählen`,
    }),
    // @../components/learningAssignmentForms/CreateGroupLearningAssignmentsForm/CreateGroupLearningAssignmentsForm.tsx:120
    'step select groups': tr({
      en: '2. Select groups',
      de: '2. Gruppen auswählen',
    }),
    // @../components/learningAssignmentForms/CreateGroupLearningAssignmentsForm/CreateGroupLearningAssignmentsForm.tsx:126
    // @../components/learningAssignmentForms/CreateUserLearningAssignmentsForm/CreateUserLearningAssignmentsForm.tsx:149
    'step select action': tr({
      en: '3. Select action',
      de: '3. Aktion auswählen',
    }),
    // @../components/learningAssignmentForms/CreateGroupLearningAssignmentsForm/CreateGroupLearningAssignmentsForm.tsx:175
    // @../components/learningAssignmentForms/CreateUserLearningAssignmentsForm/CreateUserLearningAssignmentsForm.tsx:220
    'step set due date': tr({
      en: '4. Set due date',
      de: '4. Frist festlegen',
    }),
    // @../components/learningAssignmentForms/CreateUserLearningAssignmentsForm/CreateUserLearningAssignmentsForm.tsx:229
    'step select date': tr({
      en: '4. Select date',
      de: '4. Termin auswählen',
    }),
    // @../components/learningAssignmentForms/CreateGroupLearningAssignmentsForm/CreateGroupLearningAssignmentsForm.tsx:182
    // @../components/learningAssignmentForms/CreateUserLearningAssignmentsForm/CreateUserLearningAssignmentsForm.tsx:264
    'available dates': tr({
      en: 'Available dates',
      de: 'Verfügbare Termine',
    }),
    // @../components/learningAssignmentForms/CreateGroupLearningAssignmentsForm/CreateGroupLearningAssignmentsForm.tsx:139
    // @../components/learningAssignmentForms/CreateGroupLearningAssignmentsForm/CreateGroupLearningAssignmentsForm.tsx:143
    // @../components/learningAssignmentForms/CreateUserLearningAssignmentsForm/CreateUserLearningAssignmentsForm.tsx:162
    // @../components/learningAssignmentForms/CreateUserLearningAssignmentsForm/CreateUserLearningAssignmentsForm.tsx:166
    'action suggest': tr({
      en: 'Suggest',
      de: 'Vorschlagen',
    }),
    // @../components/learningAssignmentForms/CreateGroupLearningAssignmentsForm/CreateGroupLearningAssignmentsForm.tsx:154
    // @../components/learningAssignmentForms/CreateGroupLearningAssignmentsForm/CreateGroupLearningAssignmentsForm.tsx:159
    // @../components/learningAssignmentForms/CreateUserLearningAssignmentsForm/CreateUserLearningAssignmentsForm.tsx:177
    // @../components/learningAssignmentForms/CreateUserLearningAssignmentsForm/CreateUserLearningAssignmentsForm.tsx:182
    'action assign': tr({
      en: 'Assign',
      de: 'Zuweisen',
    }),
    // @../components/learningAssignmentForms/CreateUserLearningAssignmentsForm/CreateUserLearningAssignmentsForm.tsx:194
    // @../components/learningAssignmentForms/CreateUserLearningAssignmentsForm/CreateUserLearningAssignmentsForm.tsx:203
    'action book': tr({
      en: 'Book',
      de: 'Buchen',
    }),
    // @../components/learningAssignmentForms/CreateGroupLearningAssignmentsForm/CreateGroupLearningAssignmentsForm.tsx:98
    // @../components/learningAssignmentForms/CreateUserLearningAssignmentsForm/CreateUserLearningAssignmentsForm.tsx:121
    'learning item not allowed': tr({
      en: 'Not available',
      de: 'Nicht verfügbar',
    }),
    // @../pages/ManageUserPage/ManageUserPageLearningAssignments.tsx:291
    'cta cancel booking': tr({
      en: 'Cancel booking',
      de: 'Buchung stornieren',
    }),
  },
  /*
   * edit learning
   **********************************************************************/
  'edit learning': {
    // @../pages/EditLearningItemPage/EditLearningItemPage.tsx:30
    'edit learning item': tr({
      en: 'Edit',
      de: 'Bearbeiten',
    }),
    // @../pages/CoursesPage/CoursesPage.tsx:195
    'cta create learning item': tr({
      en: 'New Course',
      de: 'Neuer Kurs',
    }),
    // @../pages/CoursesPage/CoursesPage.tsx:53
    'cta create scheduled course': tr({
      en: 'Live Training / Hybrid / Webinar',
      de: 'Live Training / Hybrid / Webinar',
    }),
    // @../pages/CoursesPage/CoursesPage.tsx:58
    'cta create on demand course': tr({
      en: 'E-Learning',
      de: 'E-Learning',
    }),
    'cta create learning path': tr({
      en: 'Learning Path',
      de: 'Lernpfad',
    }),
    // @../pages/CoursesPage/CoursesPage.tsx:182
    'sort learning items': tr({
      en: 'Sort by: {{type}}',
      de: 'Sortieren nach: {{type}}',
    }),
    // FIXME: Unused translation
    'cta sort learning items': tr({
      en: 'Sort by',
      de: 'Sortieren nach',
    }),
    // @../pages/CoursesPage/CoursesPage.tsx:65
    // @../pages/CoursesPage/CoursesPage.tsx:184
    'cta sort by start date': tr({
      en: 'Starting date',
      de: 'Startdatum',
    }),
    // @../pages/CoursesPage/CoursesPage.tsx:67
    // @../pages/CoursesPage/CoursesPage.tsx:187
    'cta sort alphabetically': tr({
      en: 'Alphabetically',
      de: 'Alphabetisch',
    }),
    // @../pages/CoursesPage/CoursesPage.tsx:68
    // @../pages/CoursesPage/CoursesPage.tsx:190
    'cta sort by created at': tr({
      en: 'Creation date',
      de: 'Erstellungsdatum',
    }),
    // @../components/EditLearningItemForm/ScheduledCourseEventsForm.tsx:209
    'cta add event': tr({
      en: 'Add Event',
      de: 'Termin hinzufügen',
    }),
    'cta add course': tr({
      en: 'Add course',
      de: 'Add course',
    }),
    'cta select course to add': tr({
      en: 'Select course to add',
      de: 'Select course to add',
    }),
    // @../components/EditLearningItemForm/ScheduledCourseEventsForm.tsx:180
    'cta add date': tr({
      en: 'Add Date',
      de: 'Termin hinzufügen',
    }),
    // @../pages/CreateLearningItemPage/CreateLearningItemPage.tsx:25
    'create scheduled course': tr({
      en: 'Create',
      de: 'Erstellen',
    }),
    'create learning path': tr({
      en: 'Create learning path',
      de: 'Create learning path',
    }),
    // @../components/EditLearningItemForm/ScheduledCourseEventsForm.tsx:97
    'new event': tr({
      en: 'New Event',
      de: 'Neuer Termin',
    }),
    // FIXME: Unused translation
    'event has {count} participants and can not edited': tr({
      en: {
        one: 'This event already has a booking and can not be edited.',
        other: 'This event already has {{count}} bookings and can not be edited.',
      },
      de: {
        one: 'Dieser Termin hat bereits eine Buchung und kann nicht bearbeitet werden.',
        other: 'Dieser Termin hat bereits {{count}} Buchungen und kann nicht bearbeitet werden.',
      },
    }),
    // @../pages/CoursePage/CoursePage.tsx:204
    'cta publish': tr({
      en: 'Publish',
      de: 'Veröffentlichen',
    }),
    // @../pages/CoursePage/CoursePage.tsx:113
    'should {course} be published': tr({
      en: 'Should the course "{{course}}" be published?',
      de: 'Soll der Kurs "{{course}}" veröffentlich werden?',
    }),
    'should {learningPath} be published': tr({
      en: 'Should the learning path "{{learningPath}}" be published?',
      de: 'Should the learning path "{{learningPath}}" be published?',
    }),
    'should {learningPath} be deprecate': tr({
      en: 'Should the learning path "{{learningPath}}" be deprecate?',
      de: 'Should the learning path "{{learningPath}}" be deprecate?',
    }),
    // @../pages/CoursePage/CoursePage.tsx:207
    'cta deprecate': tr({
      en: 'Deprecate',
      de: 'Schliessen',
    }),
    // @../pages/CoursePage/CoursePage.tsx:133
    'should {course} be deprecated': tr({
      en: 'Should the course "{{course}}" be deprecated?',
      de: 'Soll der Kurs "{{course}}" geschlossen werden?',
    }),
  },
  /*
   * user
   **********************************************************************/
  user: {
    // @../pages/ManageUsersPage/ManageUsersPage.tsx:276
    'joined at': tr({
      en: 'Joined At',
      de: 'Beigetreten',
    }),
    // @../pages/ManageGroupPage/ManageGroupPage.tsx:99
    // @../pages/ManageGroupPage/ManageGroupPage.tsx:191
    // @../pages/ManageUsersPage/ManageUsersPage.tsx:309
    'user joined at date': tr({
      en: 'Joined {{date, datetime}}',
      de: 'Beigetreten am {{date, datetime}}',
    }),
    // @../pages/ManageUsersPage/ManageUsersPage.tsx:275
    'user status': tr({
      en: 'Status',
      de: 'Status',
    }),
    // @pages/ManageUserPage/ManageUserPage.tsx (159,28)
    // @components/userAndGroupForms/CreateUserForm/CreateUserForm.tsx (91,22)
    // @pages/ManageUsersPage/ManageUsersPage.tsx (306,28)
    // @pages/ManageGroupPage/ManageGroupPage.tsx (97,26)
    // @pages/ManageGroupPage/ManageGroupPage.tsx (189,26)
    user_status: {
      // @../pages/ManageGroupPage/ManageGroupPage.tsx:100
      // @../pages/ManageGroupPage/ManageGroupPage.tsx:192
      // @../pages/ManageUserPage/ManageUserPage.tsx:258
      // @../pages/ManageUsersPage/ManageUsersPage.tsx:306
      // @../components/userAndGroupForms/CreateUserForm/CreateUserForm.tsx:142
      active: tr({
        en: 'Active',
        de: 'Aktiv',
      }),
      // @../pages/ManageGroupPage/ManageGroupPage.tsx:100
      // @../pages/ManageGroupPage/ManageGroupPage.tsx:192
      // @../pages/ManageUsersPage/ManageUsersPage.tsx:306
      inactive: tr({
        en: 'Deactivated',
        de: 'Deaktiviert',
      }),
    },
    // @pages/ManageUserPage/ManageUserPage.tsx (165,19)
    user_status_is: {
      // @../pages/ManageUserPage/ManageUserPage.tsx:266
      active: tr({
        en: 'User is active',
        de: `BenutzerIn ist aktiv`,
      }),
      // @../pages/ManageUserPage/ManageUserPage.tsx:266
      inactive: tr({
        en: 'User is deactivated',
        de: 'BenutzerIn is deaktiviert',
      }),
      // @../pages/ManageUserPage/ManageUserPage.tsx:264
      // @../pages/ManageUserPage/ManageUserPage.tsx:266
      deleted: tr({
        en: 'User was deleted',
        de: 'BenutzerIn is gelöscht',
      }),
    },
    // @../pages/ManageUserPage/ManageUserPage.tsx:196
    // @../components/userAndGroupForms/CreateUserForm/CreateUserForm.tsx:99
    firstname: tr({
      en: 'First Name',
      de: 'Vorname',
    }),
    // @../pages/ManageUserPage/ManageUserPage.tsx:197
    // @../components/userAndGroupForms/CreateUserForm/CreateUserForm.tsx:106
    lastname: tr({
      en: 'Last Name',
      de: 'Nachname',
    }),
    // @../components/comments/CommentsList/CommentsList.tsx:193
    // @../components/slugs/UserSlug/UserSlug.tsx:25
    anonymous: tr({
      en: 'Anonymous',
      de: 'Anonymous',
    }),
    // @../pages/ManageUserPage/ManageUserPage.tsx:201
    // @../components/userAndGroupForms/CreateUserForm/CreateUserForm.tsx:113
    'field position': tr({
      en: 'Position',
      de: 'Position',
    }),
    // @../pages/ManageUserPage/ManageUserPage.tsx:208
    // @../components/userAndGroupForms/CreateUserForm/CreateUserForm.tsx:127
    'field username': tr({
      en: 'Username',
      de: 'Benutzername',
    }),
    // @../pages/ManageUserPage/ManageUserPage.tsx:215
    // @../components/userAndGroupForms/CreateUserForm/CreateUserForm.tsx:120
    emailAddress: tr({
      en: 'Email address',
      de: 'E-Mail-Adresse',
    }),
    // @../pages/ManageUserPage/ManageUserPageGroupMemberships.tsx:48
    'group memberships': tr({
      en: 'Groups',
      de: 'Gruppen',
    }),
    // @../pages/ManageUserPage/ManageUserPageGroupMemberships.tsx:49
    'managed groups': tr({
      en: 'Managed Groups',
      de: 'Managed Groups',
    }),
    // @../components/userAndGroupForms/CreateUserForm/CreateUserForm.tsx:134
    'field role': tr({
      en: 'Role',
      de: 'Rolle',
    }),
    // @../pages/CoursePage/CoursePageScheduledCourse.tsx:347
    'field name': tr({
      en: 'Name',
      de: 'Name',
    }),
    role: {
      // @../components/userAndGroupForms/CreateUserForm/CreateUserForm.tsx:40
      user: tr({
        en: 'User',
        de: 'User',
      }),
      // @../components/userAndGroupForms/CreateUserForm/CreateUserForm.tsx:40
      advanced_user: tr({
        en: 'Advanced User',
        de: 'Advanced User',
      }),
      // @../components/userAndGroupForms/CreateUserForm/CreateUserForm.tsx:40
      admin: tr({
        en: 'Admin',
        de: 'Admin',
      }),
      // @../components/userAndGroupForms/CreateUserForm/CreateUserForm.tsx:40
      auditor: tr({
        en: 'Auditor',
        de: 'Auditor',
      }),
      // @../components/userAndGroupForms/CreateUserForm/CreateUserForm.tsx:40
      customer_success_manager: tr({
        en: 'Customer Success Manager',
        de: 'Customer Success Manager',
      }),
      trainer: tr({
        en: 'External user',
        de: 'External user',
      }),
    },
    // @../pages/ManageUserPage/ManageUserPage.tsx:282
    'password reset required': tr({
      en: 'The user must set a new password on next login.',
      de: 'Der/die BenutzerIn muß beim nächsten Anmelden ein neues Passwort vergeben.',
    }),
  },
  /*
   * manage user
   **********************************************************************/
  'manage user': {
    // @../pages/ManageUsersPage/ManageUsersPage.tsx:217
    'cta activate user': tr({
      en: 'Activate',
      de: 'Aktivieren',
    }),
    // @../pages/ManageUsersPage/ManageUsersPage.tsx:222
    'cta deactivate user': tr({
      en: 'Deactivate',
      de: 'Deaktivieren',
    }),
    // @../pages/ManageUserPage/ManageUserPage.tsx:279
    'cta reset password': tr({
      en: 'Reset password',
      de: 'Passwort zurücksetzen',
    }),
    // @../pages/ManageUsersPage/ManageUsersPage.tsx:50
    'should {count} users be deactivated': tr({
      en: {
        one: 'Deactivate this user?',
        other: 'Deactivate these {{count}} users?',
      },
      de: {
        one: 'Diese/n Benutzer/in deaktivieren?',
        other: 'Diese {{count}} Benutzer/innen deaktivieren?',
      },
    }),
    // @../pages/ManageUsersPage/ManageUsersPage.tsx:49
    'should {count} users be activated': tr({
      en: {
        one: 'Activate this user?',
        other: 'Activate these {{count}} users?',
      },
      de: {
        one: 'Diese/n Benutzer/in aktivieren?',
        other: 'Diese {{count}} Benutzer/innen aktivieren?',
      },
    }),
    // @../pages/CreateUserPage/CreateUserPage.tsx:17
    // @../pages/ManageUsersPage/ManageUsersPage.tsx:255
    // @../components/userAndGroupForms/CreateUserForm/CreateUserForm.tsx:91
    'create user': tr({
      en: 'New User',
      de: 'Neuer Benutzer',
    }),
    // @../pages/ManageUserPage/ManageUserPage.tsx:288
    'cta delete': tr({
      en: 'Delete',
      de: 'Löschen',
    }),
    // @../pages/ManageUserPage/ManageUserPage.tsx:113
    'should {user} be deleted': tr({
      en: 'Really delete <0/>?',
      de: 'Soll <0/> wirklich gelöscht werden?',
    }),
    // @../pages/ManageUserPage/ManageUserPage.tsx:129
    'user was deleted': tr({
      en: 'The user was deleted.',
      de: 'Der/die BenutzerIn wurde gelöscht.',
    }),
  },
  /*
   * group
   **********************************************************************/
  group: {
    // @../pages/GroupCommentPage/GroupCommentPage.tsx:31
    'cta back to group': tr({
      en: 'Back to group',
      de: 'Zurück zur Gruppe',
    }),
    // @../pages/ManageGroupPage/ManageGroupPage.tsx:58
    // @../pages/ManageGroupsPage/ManageGroupsPage.tsx:68
    // @../components/userAndGroupForms/CreateGroupForm/CreateGroupForm.tsx:61
    'group managers': tr({
      en: 'Group managers',
      de: 'GruppenmanagerInnen',
    }),
    // @../pages/ManageGroupPage/ManageGroupPage.tsx:96
    'user is also group member': tr({
      en: 'User is also group member',
      de: 'BenutzerIn ist auch Gruppenmitglied',
    }),
    // @../pages/ManageGroupPage/ManageGroupPage.tsx:188
    'user is also group manager': tr({
      en: 'User is also group manager',
      de: 'BenutzerIn ist auch GruppenmanagerIn',
    }),
    // @../pages/ManageGroupPage/ManageGroupPage.tsx:151
    // @../components/userAndGroupForms/CreateGroupForm/CreateGroupForm.tsx:66
    'group members': tr({
      en: 'Members',
      de: 'Mitglieder',
    }),
    // @../components/userAndGroupForms/CreateGroupForm/CreateGroupForm.tsx:57
    'group name': tr({
      en: 'Group name',
      de: 'Gruppenname',
    }),
    // @../pages/ManageGroupsPage/ManageGroupsPage.tsx:89
    group_createdAt_date: tr({
      en: 'Created at {{date, datetime}}',
      de: 'Erstellt am {{date, datetime}}',
    }),
    // @../pages/ManageGroupsPage/ManageGroupsPage.tsx:86
    group_number_of_members: tr({
      en: {
        zero: 'No user',
        one: '1 user',
        other: '{{count}} users',
      },
      de: {
        zero: 'Keine BenutzerInnen',
        one: '1 Benutzer',
        other: '{{count}} BenutzerInnen',
      },
    }),
    // @../pages/ManageGroupsPage/ManageGroupsPage.tsx:69
    'number of members': tr({
      en: 'Number of Members',
      de: 'Mitgliederanzahl',
    }),
    // @../pages/ManageGroupsPage/ManageGroupsPage.tsx:70
    'created at': tr({
      en: 'Created At',
      de: 'Erstellt am',
    }),
    // @../components/notificationComponents/notificationComponents.tsx:84
    // @../components/notificationComponents/notificationComponents.tsx:107
    // @../components/notificationComponents/notificationComponents.tsx:130
    // @../components/notificationComponents/notificationComponents.tsx:153
    // @../components/notificationComponents/notificationComponents.tsx:284
    // @../components/notificationComponents/notificationComponents.tsx:313
    // @../components/notificationComponents/notificationComponents.tsx:584
    // @../components/notificationComponents/notificationComponents.tsx:611
    'cta view': tr({
      en: 'View group',
      de: 'Gruppe ansehen',
    }),
  },
  /*
   * manage group
   **********************************************************************/
  'manage group': {
    // @../components/userAndGroupForms/AddMembersToGroupsForm/AddMembersToGroupsForm.tsx:43
    'add group members': tr({
      en: `Add members`,
      de: `Mitglieder hinzufügen`,
    }),
    // @../pages/ManageGroupPage/ManageGroupPage.tsx:166
    'add members': tr({
      en: 'Add members',
      de: 'Mitglieder hinzufügen',
    }),
    // @../pages/ManageGroupPage/ManageGroupPage.tsx:74
    // @../components/userAndGroupForms/AddGroupManagersToGroupsForm/AddGroupManagersToGroupsForm.tsx:46
    'add group managers': tr({
      en: 'Add group managers',
      de: 'GruppenmanagerInnen hinzufügen',
    }),
    // @../pages/AddGroupManagersToGroupPage/AddGroupManagersToGroupPage.tsx:22
    // @../pages/AddGroupMembershipsToUserPage/AddGroupMembershipsToUserPage.tsx:21
    // @../pages/AddGroupMembershipsToUsersPage/AddGroupMembershipsToUsersPage.tsx:22
    // @../pages/AddMembersToGroupPage/AddMembersToGroupPage.tsx:22
    // @../pages/ManageUsersPage/ManageUsersPage.tsx:163
    // @../components/userAndGroupForms/AddGroupMembershipsToUsersForm/AddGroupMembershipsToUsersForm.tsx:46
    'add to group': tr({
      en: 'Add to group',
      de: 'Zu Gruppe hinzufügen',
    }),
    // @../pages/ManageUserPage/ManageUserPageGroupMemberships.tsx:53
    'add to groups': tr({
      en: 'Add to groups',
      de: 'Zu Gruppen hinzufügen',
    }),
    // @../components/GroupUserOperations/GroupUserOperations.tsx:142
    'add as group manager': tr({
      en: 'Make group manager',
      de: 'Als GruppenmanagerIn hinzufügen',
    }),
    // @../components/GroupUserOperations/GroupUserOperations.tsx:179
    'add as group member': tr({
      en: 'Add as member',
      de: 'Als Gruppenmitglied hinzufügen',
    }),
    // @../components/GroupUserOperations/GroupUserOperations.tsx:126
    'remove as group manager': tr({
      en: 'Remove as group manager',
      de: 'Als GruppenmanagerIn entfernen',
    }),
    // @../components/GroupUserOperations/GroupUserOperations.tsx:163
    'remove as group member': tr({
      en: 'Remove as member',
      de: 'Als Gruppenmitglied entfernen',
    }),
    // @../components/userAndGroupForms/RemoveGroupMembershipsFromUsersForm/RemoveGroupMembershipsFromUsersForm.tsx:92
    'available groups': tr({
      en: 'Available groups',
      de: 'Verfügbare Gruppen',
    }),
    // @../pages/CreateGroupPage/CreateGroupPage.tsx:18
    // @../pages/ManageGroupsPage/ManageGroupsPage.tsx:57
    // @../components/userAndGroupForms/CreateGroupForm/CreateGroupForm.tsx:52
    'create group': tr({
      en: 'New group',
      de: 'Neue Gruppe',
    }),
    // @../pages/ManageUsersPage/ManageUsersPage.tsx:184
    'remove from group': tr({
      en: 'Remove from group',
      de: 'Aus Gruppe entfernen',
    }),
    // @../pages/RemoveGroupMembershipsFromUsersPage/RemoveGroupMembershipsFromUsersPage.tsx:24
    // @../components/userAndGroupForms/RemoveGroupMembershipsFromUsersForm/RemoveGroupMembershipsFromUsersForm.tsx:84
    'remove from groups': tr({
      en: 'Remove from groups',
      de: 'Aus Gruppen entfernen',
    }),
    // @../components/userAndGroupForms/RemoveGroupMembershipsFromUsersForm/RemoveGroupMembershipsFromUsersForm.tsx:108
    'selected groups': tr({
      en: 'Selected groups',
      de: 'Ausgewählte Gruppen',
    }),
    // @../components/GroupUserOperations/GroupUserOperations.tsx:49
    'should user be removed as member from group': tr({
      en: 'Remove member <0/> from group <1/>?',
      de: 'Soll das Mitglied <0/> aus der Gruppe <1/> entfernt werden?',
    }),
    // @../components/GroupUserOperations/GroupUserOperations.tsx:54
    'the user will still be group manager of this group': tr({
      en: 'The user will still be group manager for this group.',
      de: 'Der/die BenutzerIn wird GruppenmanagerIn der Gruppe bleiben.',
    }),
    // @../components/GroupUserOperations/GroupUserOperations.tsx:77
    'should user be removed as group manager from group': tr({
      en: 'Remove group manager <0/> from group <1/>?',
      de: 'Soll der/die GruppenmanagerIn <0/> aus der Gruppe <1/> entfernt werden?',
    }),
    // @../components/GroupUserOperations/GroupUserOperations.tsx:82
    'the user will still be member of this group': tr({
      en: 'The user will still be a member of this group.',
      de: 'Der/die BenutzerIn wird Mitglied der Gruppe bleiben.',
    }),
    // @../pages/ManageGroupsPage/ManageGroupsPage.tsx:41
    // @../pages/ManageGroupsPage/ManageGroupsPage.tsx:120
    'title manage groups': tr({
      en: 'Manage groups',
      de: 'Gruppen verwalten',
    }),
  },
  /*
   * login and password
   **********************************************************************/
  'login password': {
    // @../pages/ManageUserPage/ManageUserPage.tsx:273
    // @../components/userAndGroupForms/SetPasswordForm/SetPasswordForm.tsx:109
    'cta set password': tr({
      en: 'Change password',
      de: 'Passwort ändern',
    }),
    // @../components/LoginForm/LoginForm.tsx:101
    'forgot your password?': tr({
      en: 'Forgot your password?',
      de: 'Passwort vergessen?',
    }),
    // @../components/LoginForm/LoginForm.tsx:175
    'reset password': tr({
      en: 'Reset password',
      de: 'Passwort zurücksetzen',
    }),
    // @../components/userAndGroupForms/SetPasswordForm/SetPasswordForm.tsx:76
    'set password': tr({
      en: 'Set new password',
      de: 'Neues Passwort setzen',
    }),
    // @../components/LoginForm/LoginForm.tsx:195
    'request password reset': tr({
      en: 'Reset password',
      de: 'Passwort zurücksetzen',
    }),
    // @../components/LoginForm/LoginForm.tsx:141
    'Password reset email sent': tr({
      en: 'We have sent you an email with a link for resetting your password.',
      de: `Wir haben Dir einen Link zum Zurücksetzen des Passworts per E-Mail geschickt.`,
    }),
    // @../components/LoginForm/LoginForm.tsx:129
    'contact admin for password reset': tr({
      en: "Please contact your companie's Skillfit administrator and ask them to reset your password.",
      de: 'Bitte kontaktiere den/die Skillfit-AdministratorIn Deiner Firma um Dein Passwort zurücksetzen zu lassen.',
    }),
    // @../components/userAndGroupForms/SetPasswordForm/SetPasswordForm.tsx:34
    'passwords do not match': tr({
      en: 'The passwords do not match.',
      de: 'Die Passworte stimmen nicht überein.',
    }),
    // @../components/userAndGroupForms/SetPasswordForm/SetPasswordForm.tsx:57
    'Your password was reset': tr({
      en: 'Your password was reset.',
      de: `Dein Passwort wurde zurückgesetzt.`,
    }),
    // @../components/userAndGroupForms/SetPasswordForm/SetPasswordForm.tsx:79
    'current password': tr({
      en: 'Current Password',
      de: 'Aktuelles Passwort',
    }),
    // @../components/userAndGroupForms/SetPasswordForm/SetPasswordForm.tsx:89
    'new password': tr({
      en: 'New Password',
      de: 'Neues Passwort',
    }),
    // @../components/userAndGroupForms/SetPasswordForm/SetPasswordForm.tsx:99
    'new password repeat': tr({
      en: 'Repeat New Password',
      de: 'Neues Passwort wiederholen',
    }),
    // @../pages/ManageUserPage/ManageUserPage.tsx:58
    'should the password for {user} be reset': tr({
      en: 'Should the password for user <0/> be reset?',
      de: 'Soll das Password für Benutzer/In <0/> zurückgesetzt werden?',
    }),
    // @../pages/ManageUserPage/ManageUserPage.tsx:86
    'Password reset email sent to user': tr({
      en: 'We have sent the user an email with a link for resetting their password.',
      de: 'Wir haben dem/der BenutzerIn einen Link zum zurücksetzen des Passworts per E-Mail geschickt.',
    }),
    // @../components/userAndGroupForms/CreateUserForm/OnboardingDialog.tsx:40
    'password reset url is': tr({
      en: 'The user can reset their password by visiting the following URL:',
      de: 'Der/die BenutzerIn kann sein/ihr Passwort unter der folgenden URL zurücksetzen:',
    }),
    // @../components/userAndGroupForms/CreateUserForm/OnboardingDialog.tsx:42
    'initial login credentials are': tr({
      en: 'The user can log in with the following credentials:',
      de: 'Der/die BenutzerIn kann sich mit den folgenden Zugangsdaten anmelden:',
    }),
    // @../components/userAndGroupForms/CreateUserForm/OnboardingDialog.tsx:44
    'initial login credentials are {username} and {password}': tr({
      en: 'Username: {{username}} / Password: {{password}}',
      de: 'Benutzername: {{username}} / Passwort: {{password}}',
    }),
    // @../components/userAndGroupForms/CreateUserForm/OnboardingDialog.tsx:48
    'cta download onboarding instructions as pdf': tr({
      en: 'Download login instructions for the user as PDF.',
      de: 'Zugangsinformationen für den/die BenutzerIn als PDF herunterladen.',
    }),
    // @../components/LoginForm/LoginForm.tsx:105
    login: tr({
      en: 'Log in',
      de: 'Einloggen',
    }),
    // @../components/LoginForm/LoginForm.tsx:93
    password: tr({
      en: 'Password',
      de: 'Passwort',
    }),
    // @../components/LoginForm/LoginForm.tsx:84
    loginTitle: tr({
      en: 'Login',
      de: 'Anmelden',
    }),
    // @../components/MainNav/MainNav.tsx:101
    // @../components/Page/Page.tsx:99
    logout: tr({
      en: 'Log out',
      de: 'Abmelden',
    }),
    // @../components/LoginForm/LoginForm.tsx:86
    // @../components/LoginForm/LoginForm.tsx:186
    'field username or email': tr({
      en: 'Email Address or Username',
      de: 'E-Mail-Adresse oder Benutzername',
    }),
  },
  /*
   * category
   **********************************************************************/
  category: {
    // @../components/EditCategoryForm/EditCategoryForm.tsx:48
    'field name': tr({
      en: 'Name',
      de: 'Name',
    }),
    // @../components/EditCategoryForm/EditCategoryForm.tsx:49
    'field shortDescription': tr({
      en: 'Short Description',
      de: 'Kurzbeschreibung',
    }),
    // @../components/EditCategoryForm/EditCategoryForm.tsx:50
    'field longDescription': tr({
      en: 'Description',
      de: 'Beschreibung',
    }),
    // @../components/formElements/SelectCategories/SelectCategories.tsx:46
    // @../components/formElements/SelectTrainers/SelectTrainers.tsx:52
    'cta create': tr({
      en: 'New',
      de: 'Neu',
    }),
    // @../components/EditCategoryForm/EditCategoryForm.tsx:46
    'create new category': tr({
      en: 'Create Category',
      de: 'Kategorie anlegen',
    }),
  },
  /*
   * provider
   **********************************************************************/
  provider: {
    // @../components/EditProviderForm/EditProviderForm.tsx:52
    'field name': tr({
      en: 'Name',
      de: 'Name',
    }),
    // @../components/EditProviderForm/EditProviderForm.tsx:55
    'field global': tr({
      en: 'Global Provider',
      de: 'Mandantenübergreifender Anbieter',
    }),
    // @../components/formElements/SelectProvider/SelectProvider.tsx:44
    'cta create': tr({
      en: 'New',
      de: 'Neu',
    }),
    // @../components/EditProviderForm/EditProviderForm.tsx:50
    'create new provider': tr({
      en: 'Create Provider',
      de: 'Anbieter anlegen',
    }),
  },
  /*
   * trainer
   **********************************************************************/
  trainer: {
    // @../components/EditTrainerForm/EditTrainerForm.tsx:50
    'create new trainer': tr({
      en: 'Create new Trainer',
      de: 'Neue/n Trainer/In anlegen',
    }),
    // @../components/EditTrainerForm/EditTrainerForm.tsx:55
    'create global': tr({
      en: 'Available to all clients',
      de: 'Für alle Mandanten verfügbar',
    }),
    // @../components/EditTrainerForm/EditTrainerForm.tsx:52
    'field firstname': tr({
      en: 'Firstname',
      de: 'Vorname',
    }),
    // @../components/EditTrainerForm/EditTrainerForm.tsx:53
    'field lastname': tr({
      en: 'Lastname',
      de: 'Nachname',
    }),
  },
  /*
   * comment
   **********************************************************************/
  comment: {
    // @../pages/CourseCommentPage/CourseCommentPage.tsx:52
    // @../pages/GroupCommentPage/GroupCommentPage.tsx:52
    // @../components/comments/ThreadsDisplay/ThreadsDisplay.tsx:91
    'field comments': tr({
      en: 'Discussion',
      de: 'Diskussion',
    }),
    // @../components/comments/CreateThreadForm/CreateThreadForm.tsx:50
    // @../components/comments/EditCommentForm/EditCommentForm.tsx:56
    'field title': tr({
      en: 'Topic',
      de: 'Thema',
    }),
    // @../components/comments/CommentsList/CommentsList.tsx:69
    // @../components/comments/CreateThreadForm/CreateThreadForm.tsx:51
    // @../components/comments/EditCommentForm/EditCommentForm.tsx:57
    'field text': tr({
      en: 'Text',
      de: 'Text',
    }),
    // @../components/comments/CommentsList/CommentsList.tsx:106
    'cta reply': tr({
      en: 'Reply',
      de: 'Antworten',
    }),
    // @../components/comments/ThreadsDisplay/ThreadsDisplay.tsx:61
    '{count} replies': tr({
      en: {
        zero: 'No replies',
        one: '1 reply',
        other: '{{count}} replies',
      },
      de: {
        zero: 'Keine Antworten',
        one: '1 Antwort',
        other: '{{count}} Antworten',
      },
    }),
    // @../components/comments/ThreadsDisplay/ThreadsDisplay.tsx:106
    'comments empty': tr({
      en: 'No postings yet',
      de: 'Noch keine Beiträge.',
    }),
    // @../components/comments/CommentsList/CommentsList.tsx:206
    'this comment was deleted': tr({
      en: 'This posting was deleted.',
      de: 'Dieser Beitrag wurde gelöscht.',
    }),
    // @../components/comments/ThreadsDisplay/ThreadsDisplay.tsx:49
    'deleted comment title': tr({
      en: 'Deleted posting',
      de: 'Gelöschter Beitrag',
    }),
    // @../components/comments/ThreadsDisplay/ThreadsDisplay.tsx:94
    'cta new thread': tr({
      en: 'New topic',
      de: 'Neues Thema',
    }),
    // @../components/comments/CreateThreadForm/CreateThreadForm.tsx:45
    'title create thread': tr({
      en: 'New topic',
      de: 'Neues Thema',
    }),
    // @../components/comments/CommentsList/CommentsList.tsx:147
    'cta delete': tr({
      en: 'Delete',
      de: 'Löschen',
    }),
    // @../components/comments/CommentsList/CommentsList.tsx:134
    'should comment be deleted': tr({
      en: 'Should this posting be deleted?',
      de: 'Soll dieser Beitrag gelöscht werden?',
    }),
    // @../components/comments/CommentsList/CommentsList.tsx:178
    'cta delete permanently': tr({
      en: 'Delete with all replies',
      de: 'Mit allen Antworten löschen',
    }),
    // @../components/comments/CommentsList/CommentsList.tsx:158
    'should comment be deleted permanently': tr({
      en: 'Should this posting and all replies to it be deleted permanently?',
      de: 'Soll dieser Beitrag mit allen Antworten dauerhaft gelöscht werden?',
    }),
    // @../components/comments/EditCommentForm/EditCommentForm.tsx:51
    'title edit comment': tr({
      en: 'Edit Posting',
      de: 'Beitrag bearbeiten',
    }),
  },
  /*
   * everything else
   **********************************************************************/
  // @../components/slugs/Slugs/Slugs.tsx:20
  'and <count> more': tr({
    en: 'and {{count}} more',
    de: 'und {{count}} weitere',
  }),
  // @../components/userAndGroupForms/CreateGroupForm/CreateGroupForm.tsx:70
  // @../components/userAndGroupForms/CreateUserForm/CreateUserForm.tsx:147
  Create: tr({
    en: ``,
    de: ``,
  }),
  // @../components/MainNav/MainNav.tsx:87
  // @../pages/ManageUsersPage/ManageUsersPage.tsx:274
  groups: tr({
    en: 'Groups',
    de: 'Gruppen',
  }),
  // @../pages/ManageGroupPage/ManageGroupPageLearningAssignments.tsx:223
  // @../pages/ManageUserPage/ManageUserPageLearningAssignments.tsx:406
  'learning assignments': tr({
    en: 'Courses',
    de: 'Kurse',
  }),
  'trainer assignments': tr({
    en: 'My personal lectures',
    de: 'Meine Lehrveranstaltungen',
  }),
  'learning paths assignments': tr({
    en: 'Learning paths',
    de: 'Lernpfade',
  }),
  // @../pages/ManageGroupPage/ManageGroupPageLearningAssignments.tsx:174
  // @../pages/ManageUserPage/ManageUserPageAchievements.tsx:46
  // @../pages/ManageUserPage/ManageUserPageLearningAssignments.tsx:339
  assignment: tr({
    en: 'Assignment',
    de: 'Zuweisung',
  }),
  // @../components/MainNav/MainNav.tsx:70
  // @../pages/ManagePage/ManagePage.tsx:9
  // @../pages/ManagePage/ManagePage.tsx:16
  manage: tr({
    en: 'Manage',
    de: 'Manage',
  }),
  // @../components/MainNav/MainNav.tsx:95
  // @../components/Page/Page.tsx:92
  myProfile: tr({
    en: 'My profile',
    de: 'Mein Profil',
  }),
  // @../pages/EventDateAttendeesListPage/EventDateAttendeesList.tsx:84
  // @../pages/ManageGroupPage/ManageGroupPage.tsx:264
  // @../pages/ManageGroupsPage/ManageGroupsPage.tsx:67
  // @../pages/ManageUsersPage/ManageUsersPage.tsx:273
  name: tr({
    en: 'Name',
    de: 'Name',
  }),
  // @../pages/ManageGroupsPage/ManageGroupsPage.tsx:48
  'search groups': tr({
    en: 'Search groups',
    de: 'Gruppen suchen',
  }),
  // FIXME: Unused translation
  'search learning items': tr({
    en: 'Search learning items',
    de: 'Kurse & Lernpfade suchen',
  }),
  // @../pages/CoursePage/CoursePageScheduledCourse.tsx:332
  // @../pages/ManageGroupPage/ManageGroupPage.tsx:64
  // @../pages/ManageGroupPage/ManageGroupPage.tsx:157
  // @../pages/ManageUsersPage/ManageUsersPage.tsx:239
  // @../components/learningAssignmentForms/CreateUserLearningAssignmentsForm/CreateUserLearningAssignmentsForm.tsx:145
  // @../components/userAndGroupForms/AddGroupManagersToGroupsForm/AddGroupManagersToGroupsForm.tsx:52
  // @../components/userAndGroupForms/AddMembersToGroupsForm/AddMembersToGroupsForm.tsx:49
  // @../components/userAndGroupForms/CreateGroupForm/CreateGroupForm.tsx:62
  // @../components/userAndGroupForms/CreateGroupForm/CreateGroupForm.tsx:67
  'search users': tr({
    en: 'Search users',
    de: 'Benutzer suchen',
  }),
  // @../pages/TestPage/TestPage.tsx:448
  test: tr({
    en: ``,
    de: ``,
  }),
  // @../pages/ManageUserPage/ManageUserPageGroupMemberships.tsx:74
  'user is group manager': tr({
    en: 'Group admin',
    de: 'GruppenmanagerIn',
  }),
  // @../pages/ManageUserPage/ManageUserPageGroupMemberships.tsx:73
  'user is group member': tr({
    en: 'Member',
    de: 'Mitglied',
  }),
  // @../pages/ManageUsersPage/ManageUsersPage.tsx:232
  // @../pages/ManageUsersPage/ManageUsersPage.tsx:340
  'manage users': tr({
    en: 'Manage Users',
    de: 'Benutzer verwalten',
  }),
  // @../components/MainNav/MainNav.tsx:84
  users: tr({
    en: 'Users',
    de: 'User',
  }),
  // FIXME: Unused translation
  'course title': tr({
    en: 'Course Title',
    de: 'Kurs',
  }),
  // @../pages/ManageUserPage/ManageUserPageAchievements.tsx:113
  achievements: tr({
    en: 'Achievements',
    de: 'Lernhistorie',
  }),
  // @../pages/ManageUsersPage/ManageUsersPage.tsx:316
  'no users found': tr({
    en: 'No users found',
    de: 'Keine BenutzerInnen gefunden',
  }),
  // @../pages/ManageGroupPage/ManageGroupPageLearningAssignments.tsx:237
  // @../pages/ManageUserPage/ManageUserPageLearningAssignments.tsx:435
  'no learning assignments found': tr({
    en: 'No learning assignments yet',
    de: 'Noch keine Lernzuweisungen',
  }),
  'no trainer assignments found': tr({
    en: 'No as trainer assignments yet',
    de: 'No as trainer assignments yet',
  }),
  'no learning paths assignments found': tr({
    en: 'No learning paths assignments yet',
    de: 'Noch keine Lernpfaden',
  }),
  // @../pages/ManageGroupPage/ManageGroupPage.tsx:107
  'no group managers found': tr({
    en: 'No group managers found',
    de: 'Keine GruppenmanagerInnen gefunden',
  }),
  // @../pages/ManageGroupPage/ManageGroupPage.tsx:199
  'no members found': tr({
    en: 'No members found',
    de: 'Keine Mitglieder gefunden',
  }),
  // @../pages/ManageUserPage/ManageUserPageGroupMemberships.tsx:81
  'no group memberships found': tr({
    en: 'Does not belong to any group',
    de: 'Gehört keiner Gruppe an',
  }),
  // @../pages/ManageUserPage/ManageUserPageAchievements.tsx:120
  'no achievements found': tr({
    en: 'No achievements yet',
    de: 'Noch keine Achievements',
  }),
  // @../pages/ManageGroupsPage/ManageGroupsPage.tsx:96
  'no groups found': tr({
    en: 'No groups found',
    de: 'Keine Gruppen gefunden',
  }),
  // @../pages/InsightsPage/InsightsPageFinishedLearningItems.tsx:42
  // @../pages/InsightsPage/InsightsPageFinishedLearningItems.tsx:58
  'learning assignment started at': tr({
    en: 'Started',
    de: 'Angefangen',
  }),
  // @../pages/InsightsPage/InsightsPageFinishedLearningItems.tsx:43
  // @../pages/InsightsPage/InsightsPageFinishedLearningItems.tsx:62
  'learning assignment finished at': tr({
    en: 'Finished',
    de: 'Abgeschlossen',
  }),
  // @../pages/InsightsPage/InsightsPageFinishedLearningItems.tsx:34
  'finished learning items': tr({
    en: 'Finished Courses & Learning Paths',
    de: 'Abgeschlossene Kurse & Lernpfade',
  }),
  // @../pages/InsightsPage/InsightsPageFinishedLearningItems.tsx:80
  'no finished learning items found': tr({
    en: 'No finished learning items yet',
    de: 'Noch keine abgeschlossenen Lerneinheiten',
  }),
  // @../pages/InsightsPage/InsightsPageFinishedLearningItems.tsx:41
  // @../pages/InsightsPage/InsightsPageFinishedLearningItems.tsx:52
  title: tr({
    en: 'Title',
    de: 'Titel',
  }),
  // FIXME: Unused translation
  'change avatar': tr({
    en: 'Change',
    de: 'Ändern',
  }),
  // @../pages/ManageUserPage/ManageUserPageAchievements.tsx:73
  // @../pages/ManageUserPage/ManageUserPageLearningAssignments.tsx:118
  // @../pages/ManageUserPage/ManageUserPageLearningAssignments.tsx:150
  '{duration} spent': tr({
    en: '{{duration, duration}} spent learning',
    de: '{{duration, duration}} investiert',
  }),
  // @../pages/ErrorPage/ErrorPage.tsx:18
  'back to homepage': tr({
    en: 'Back to Homepage',
    de: 'Zurück zur Startseite',
  }),
  // @../pages/ManageUserPage/ManageUserPageLearningAssignments.tsx:351
  activity: tr({
    en: 'Activity',
    de: 'Aktivität',
  }),
  // @../pages/ManageGroupPage/ManageGroupPageLearningAssignments.tsx:185
  progress: tr({
    en: 'Progress',
    de: 'Fortschritt',
  }),
  // @../components/EditLearningItemForm/EditLearningItemForm.tsx:189
  // @../components/userAndGroupForms/UserAvatarForm/UserAvatarForm.tsx:60
  'cta crop image': tr({
    en: 'Crop image',
    de: 'Bildausschnitt anpassen',
  }),
  // @../components/basics/ImageInput/CropImageDialog.tsx:79
  'crop image title': tr({
    en: 'Crop image',
    de: 'Bildausschnitt anpassen',
  }),
  learning_assignments: {
    participants_details: {
      'no participants': tr({
        en: 'no participants',
        de: 'no participants',
      }),
      'user column title': tr({
        en: 'User',
        de: 'User',
      }),
      'progress column title': tr({
        en: 'Progress',
        de: 'Progress',
      }),
      'status column title': tr({
        en: 'Status',
        de: 'Status',
      }),
      'duration column title': tr({
        en: 'Duration',
        de: 'Duration',
      }),
      'status not booked': tr({
        en: 'not booked',
        de: 'nicht gebucht',
      }),
      'status not started': tr({
        en: 'not startet',
        de: 'nicht gestartet',
      }),
      'status not showed up yet': tr({
        en: 'not showed up yet',
        de: 'nicht teilgenommen',
      }),
      'status in progress': tr({
        en: 'in progress',
        de: 'im Gange',
      }),
      'status failed': tr({
        en: 'failed',
        de: 'fehlgeschlagen',
      }),
      'status passed': tr({
        en: 'passed',
        de: 'abgeschlossen',
      }),
    },
  },
}
